import { Modal, Tabs, Tooltip, InputNumber, Spin, Input } from 'antd';
import React, { useCallback, useState } from 'react';
import { CollectionServer, errorCatch, GET, JSXMap, POST, QueryDetail, QueryOrder, QueryParam, useAuth, useTranslateContext } from 'fennec-ui';
import Icofont from 'react-icofont';
import { BgColorsOutlined, CalculatorOutlined, DiffOutlined, ExclamationCircleOutlined, FileDoneOutlined, IssuesCloseOutlined, LoadingOutlined, ReloadOutlined } from '@ant-design/icons';

import EventListItem from '../../../components/EventListItem';
import { useNearestObjectContext } from '../../../../common/Context';

import dayjs from 'dayjs'
import 'dayjs/locale/ru'
import PageLayout from '../../../components/PageLayout';
import FilterFieldLabel from '../../../components/FilterFieldLabel';
import CategoryName from '../../../components/CategoryName';
import { UserName } from '../../../../common/User';
var isBetween = require('dayjs/plugin/isBetween')
var utc = require('dayjs/plugin/utc')
var timezone = require('dayjs/plugin/timezone') // dependent on utc plugin
dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.extend(isBetween)
dayjs.locale('ru');

var _ = require('lodash');

function AgentskieVoznagrazhdeniyaRow({ item, idx, eventID, disabled, disabled2, renderProps }) {
    const [collapsed, setCollapsed] = useState(true);
    const auth = useAuth()
    const {
        collection,
        setCollection,
        setCollectionItem,
        removeCollectionItem,
        collectionActions,
        modelActions,
        update,
        lastFuncStat,
        lock,
        unlock,
        loading
    } = renderProps;

    const FilterFromContextFilter = React.useCallback(() => [
        QueryParam("f-sum-summaVGonorare", 0),
        // QueryParam("f-sum-usluga.summa", 0),
        // QueryParam("f-sum-usluga.summaDoPromokoda", 0),
        // QueryParam("f-sum-summaNaNakopitelnii", 0),
        // QueryParam("f-sum-summaNaTekushchii", 0),
    ], [item, idx, eventID, disabled, disabled2]);
    const filters = () => [
        {
            name: "usluga.polzovatel.lastname",
            sort: true,
            filter: true,
        },
        {
            name: "usluga.polzovatel.firstname",
            sort: true,
            filter: true,
        },
        // {
        //     name: "usluga.polzovatel.patronymic",
        //     sort: true,
        //     filter: true,
        // },
        // {
        //     name: "usluga.polzovatel.email",
        //     sort: true,
        //     filter: true,
        // },
        // {
        //     label: <span>Телефон<span style={{
        //         fontStyle: "italic",
        //         fontSize: "11px",
        //         paddingLeft: "5px",
        //         color: "#818181"
        //     }}>(без +)</span></span>,
        //     name: "usluga.polzovatel.phone",
        //     // type: "string",
        //     sort: true,
        //     filter: true,
        // },
        {
            name: "usluga.polzovatel.gender",
            sort: true,
            filter: true,
        },
        {
            label: <FilterFieldLabel label="Услуга" badge="co" color="#919191" background="rgba(216, 216, 216, 0.2)" />,
            name: "usluga.uslugaKlientu.yacheikaUsluga.nazvanie",
            // queryComparer:"swsim", // sim, wsim, swsim
            sort: true,
            filter: true,
        },
        // {
        //     label: "Категория",
        //     name: "usluga.kategoriya.kategoriya",
        //     source: `/api/meropriyatiya/kategoriiuchastnikovnameropriyatiyakh/list/${eventID}`,
        //     displayString: (item) => {
        //         return item?.tantsevalnayaDistsiplinaPsevdonim + ", " + item?.kategoriyaUchastnikovPsevdonim
        //     },
        //     display: (item) => {
        //         return <CategoryName category={item} style={{
        //             whiteSpace: "nowrap",
        //             overflow: "hidden",
        //             textOverflow: "ellipsis",
        //         }} />
        //     },
        //     queryFilter: [
        //         QueryDetail("model"),
        //         // QueryParam("w-meropriyatie", eventID),
        //         QueryOrder("tantsevalnayaDistsiplinaPsevdonim", "ASC"),
        //         QueryOrder("kategoriyaUchastnikovPsevdonim", "ASC")
        //     ],
        //     sort: true,
        //     filter: true
        // },
        {
            label: "Сумма",
            name: "summaVGonorare",
            type: "int",
            filterType: "range",
            func: ["min", "max"],
            sort: true,
            filter: true,
        },
    ];
    const render = (items, {
        collection,
        setCollection,
        setCollectionItem,
        removeCollectionItem,
        collectionActions,
        modelActions,
        update,
        lastFuncStat,
        lock,
        unlock,
        loading
    }) => {
        const summaVGonorare = lastFuncStat?.summavgonorare?.sum || 0;
        return (<div>
            <Spin spinning={loading} tip="Загрузка...">
                <div className='scrollable' style={{ /*backgroundColor: "white"*/ }}>
                    <table className="xtable" style={{ fontSize: "13px", lineHeight: "normal" }}>
                        <thead>
                            <tr>
                                <th className={`fixed height-8`} style={{ minWidth: "180px", }}>
                                    <div className='bg bg-grey dark-1'>Услуга</div>
                                </th>

                                <th className="height-8" style={{ minWidth: "100px", fontWeight: "300" }}>
                                    <div className="bg bg-grey dark-1">
                                        Сумма в гонораре
                                    </div>
                                </th>

                                <th className={`height-8`} style={{ minWidth: "100px" }}>
                                    <div className='bg bg-grey dark-1'>Сумма</div>
                                </th>
                                <th className={`height-8`} style={{ minWidth: "100px" }}>
                                    <div className='bg bg-grey dark-1'>Сумма до промокода</div>
                                </th>
                            </tr>
                            <tr>
                                <th className={`fixed height-4`} style={{ minWidth: "180px", }}>
                                    <div className='bg bg-grey dark-1'></div>
                                </th>

                                <th className="height-4" style={{ minWidth: "100px", fontWeight: "300" }}>
                                    <div className="bg bg-green" style={{ fontWeight: "bold" }}>
                                        {/* Сумма в гонораре */}
                                        {(Number(summaVGonorare.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })}
                                    </div>
                                </th>

                                <th className={`height-4`} style={{ minWidth: "100px", }}>
                                    <div className='bg bg-grey dark-1'></div>
                                </th>
                                <th className={`height-4`} style={{ minWidth: "100px", }}>
                                    <div className='bg bg-grey dark-1'></div>
                                </th>
                            </tr>
                        </thead>
                        <tbody style={{ fontSize: "12px" }}>
                            {JSXMap(items || [], (item, cidx) => {
                                return (<tr key={cidx}>
                                    <td className={`fixed ${(item?.usluga?.kategoriya) ? "height-8" : "height-6"}`} style={{ minWidth: "180px" }}>
                                        <div>
                                            <div>{item?.usluga?.uslugaKlientu?.yacheikaUsluga?.nazvanie}</div>
                                            <div style={{
                                                filter: "grayscale(0.1)", opacity: "0.6",
                                                textAlign: "left",
                                                textWrap: "nowrap",
                                                whiteSpace: "nowrap",
                                                overflow: "hidden",
                                                textOverflow: "ellipsis",
                                                fontSize: "12px",
                                                fontWeight: "lighter"
                                            }}>
                                                {item?.usluga?.kategoriya && <div style={{
                                                    whiteSpace: "nowrap",
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                }}>
                                                    <CategoryName category={item?.usluga?.kategoriya?.kategoriya} style={{
                                                        whiteSpace: "nowrap",
                                                        overflow: "hidden",
                                                        textOverflow: "ellipsis",
                                                    }} />
                                                </div>}
                                                <UserName item={item?.usluga?.polzovatel} noborder={true} />
                                            </div>
                                            {/* <UserName item={item?.usluga?.polzovatel} noborder={true} />
                                            <div style={{
                                                color: "rgba(0, 0, 0, 0.45)",
                                                textAlign: "left",
                                                textWrap: "nowrap",
                                                whiteSpace: "nowrap",
                                                overflow: "hidden",
                                                textOverflow: "ellipsis",
                                                fontSize: "12px",
                                                fontWeight: "lighter",
                                                paddingLeft: "20px"
                                            }}>
                                                <span>{item?.vtp?.tipPolzovatelya?.opisanie}</span>
                                            </div> */}
                                        </div>
                                    </td>
                                    <td className={`${(item?.usluga?.kategoriya) ? "height-8" : "height-6"}`} style={{ minWidth: "100px" }}>
                                        <div className="bg bg-orange dark-1 border-transparent" style={{ height: "100%", padding: "2px 5px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                                            <div>
                                                {(Number(item?.summaVGonorare?.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })}
                                            </div>
                                        </div>
                                    </td>

                                    <td className={`${(item?.usluga?.kategoriya) ? "height-8" : "height-6"}`} style={{ minWidth: "100px" }}>
                                        <div className="bg bg-grey dark-1 border-transparent" style={{ height: "100%", padding: "2px 5px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                                            <div>
                                                {(Number(item?.usluga?.summa?.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })}
                                            </div>
                                        </div>
                                    </td>
                                    <td className={`${(item?.usluga?.kategoriya) ? "height-8" : "height-6"}`} style={{ minWidth: "100px" }}>
                                        <div className="bg bg-grey dark-1 border-transparent" style={{ height: "100%", padding: "2px 5px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                                            <div>
                                                {(Number(item?.usluga?.summaDoPromokoda?.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })}
                                            </div>
                                        </div>
                                    </td>

                                </tr>)
                            })}
                        </tbody>
                    </table>
                </div>
            </Spin>
        </div>)
    }
    return (<React.Fragment key={idx + "wrap"}>
        <tr key={idx}>
            <td className={`fixed pointer height-5`} style={{ minWidth: "25px", backgroundColor: "white" }} onClick={() => {
                setCollapsed(o => !o);
            }}>
                <div className={`bg ${(!collapsed) ? "bg-orange dark-5" : "bg-grey"}`} style={{ height: "100%", minWidth: "unset", textAlign: "left", padding: "2px 5px", display: "flex", justifyContent: "center", alignItems: "center", overflow: "hidden" }}>
                    {(collapsed) && <i className="fa fa-plus-square-o"></i>}
                    {(!collapsed) && <i className="fa fa-minus-square-o"></i>}
                </div>
            </td>
            <td className={`fixed height-5`} style={{ left: "25px", minWidth: "180px", backgroundColor: "white" }}>
                <div>
                    <UserName item={item?.vtp?.user} noborder={true} />
                    <div style={{
                        color: "rgba(0, 0, 0, 0.45)",
                        textAlign: "left",
                        textWrap: "nowrap",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        fontSize: "12px",
                        fontWeight: "lighter",
                        paddingLeft: "20px"
                    }}>
                        <span>{item?.vtp?.tipPolzovatelya?.opisanie}</span>
                    </div>
                </div>
            </td>
            <td className="fixed height-5" style={{ left: "205px", minWidth: "200px", backgroundColor: "white" }}>
                {item?.aktivnost && <div className='bg bg-grey light-9' style={{ height: "100%", minWidth: "unset", textAlign: "left", padding: "2px 5px", display: "flex", justifyContent: "left", alignItems: "center", overflow: "hidden" }}>
                    <div style={{
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                    }}>
                        <div style={{
                            color: "rgba(0, 0, 0, 0.45)",
                            textAlign: "left",
                            textWrap: "nowrap",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            fontSize: "12px",
                            fontWeight: "lighter"
                        }}>
                            Активность
                        </div>
                        <div style={{
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                        }}>{item?.aktivnost?.nazvanie}</div>
                    </div>
                </div>}
                {item?.kategoriya && <div className='bg bg-grey light-9' style={{ height: "100%", minWidth: "unset", textAlign: "left", padding: "2px 5px", display: "flex", justifyContent: "left", alignItems: "center", overflow: "hidden" }}>
                    <div style={{
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                    }}>
                        <div style={{
                            color: "rgba(0, 0, 0, 0.45)",
                            textAlign: "left",
                            textWrap: "nowrap",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            fontSize: "12px",
                            fontWeight: "lighter"
                        }}>
                            Категория
                        </div>
                        <CategoryName category={item?.kategoriya} style={{
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                        }} />
                    </div>
                </div>}
                {item?.promokod && <div className='bg bg-grey light-9' style={{ height: "100%", minWidth: "unset", textAlign: "left", padding: "2px 5px", display: "flex", justifyContent: "left", alignItems: "center", overflow: "hidden" }}>
                    <div style={{
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                    }}>
                        <div style={{
                            color: "rgba(0, 0, 0, 0.45)",
                            textAlign: "left",
                            textWrap: "nowrap",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            fontSize: "12px",
                            fontWeight: "lighter"
                        }}>
                            Промокод
                        </div>
                        <div style={{
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                        }}>{item?.promokod?.promokod}</div>
                    </div>
                </div>}
                {(!item?.aktivnost && !item?.kategoriya && !item?.promokod) && <div className='bg bg-grey light-9' style={{ height: "100%", minWidth: "unset", padding: "2px 5px", display: "flex", justifyContent: "left", alignItems: "center", overflow: "hidden" }}>
                    <div>

                    </div>
                </div>}
            </td>
            <td className="height-5" style={{ minWidth: "100px", backgroundColor: "white" }}>
                <div className="bg bg-blue dark-1 border-transparent" style={{ height: "100%", padding: "2px 5px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <div>
                        {(Number(item?.agentskoeVoznagrazhdenieProtsent?.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })}
                    </div>
                </div>
            </td>
            <td className="height-5" style={{ minWidth: "100px", backgroundColor: "white" }}>
                <div className="bg bg-blue dark-1 border-transparent" style={{ height: "100%", padding: "2px 5px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <div>
                        {(Number(item?.agentskoeVoznagrazhdenieSumma?.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })}
                    </div>
                </div>
            </td>
            {/* <td className="height-5" style={{ minWidth: "45px", backgroundColor: "white" }}>
                <div className="bg bg-blue dark-1 border-transparent" style={{ height: "100%", padding: "2px 5px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <div>
                        <div>{(item?.aktivno) ? "Да" : "Нет"}</div>
                    </div>
                </div>
            </td> */}
            <td className="height-5" style={{ minWidth: "100px", backgroundColor: "white" }}>
                <div className="bg bg-orange dark-1 border-transparent" style={{ height: "100%", padding: "2px 5px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <div>
                        {(Number(item?.gonorarRaschetnii?.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })}
                    </div>
                </div>
            </td>
            <td className="height-5" style={{ minWidth: "100px", backgroundColor: "white" }}>
                <div className="bg bg-blue dark-1 border-transparent" style={{ height: "100%", padding: "2px 5px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <div>
                        {(Number(item?.summaRaschetnaya?.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })}
                    </div>
                </div>
            </td>
            <td className="height-5" style={{ minWidth: "100px", backgroundColor: "white" }}>
                <div className="bg bg-blue dark-1 border-transparent" style={{ height: "100%", padding: "2px 5px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <div>
                        {(Number(item?.summaNaNakopitelnii?.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })}
                    </div>
                </div>
            </td>
            <td className="height-5" style={{ minWidth: "100px", backgroundColor: "white" }}>
                <div className="bg bg-blue dark-1 border-transparent" style={{ height: "100%", padding: "2px 5px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <div>
                        {(Number(item?.summaNaTekushchii?.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })}
                    </div>
                </div>
            </td>
        </tr>
        {(!collapsed) && <tr key={idx + "ext"}>
            <td colSpan={10}>
                <div className="bg bg-orange border-grey" style={{ borderColor: "darkgrey", textAlign: "left", marginLeft: "25px", paddingTop: "10px", marginTop: "5px", marginBottom: "5px" }}>
                    {item && <CollectionServer
                        auth={auth}
                        floatingFilter={true}
                        disableScrollTo={true}
                        headerStyle={{ flexDirection: "row-reverse" }}
                        footerStyle={{ flexDirection: "row-reverse" }}
                        filterPopoverPlacement="bottomLeft"
                        // onCollectionChange={(items) => {
                        //     if (items && items.length) {
                        //         const disabled = items[0]?.meropriyatie?.raschetAgentskikhProizveden;
                        //         const disabled2 = !disabled || items[0]?.meropriyatie?.dokAgentskikhVoznagrSozdani;
                        //         setDisabled(disabled)
                        //         setDisabled2(disabled2)
                        //     }
                        // }}
                        name={"OkazannieUslugiVAgentskikh"}
                        count={() => 10} // !!!! ИСПРАВИТЬ - сделать редактируемым или подобрать нужное количество !!!!
                        // queryDetail={"collection"}
                        source={`/api/agentskie-voznagrazhdeniya/by-user/uslugi/page/${item?.ID}`}
                        contextFilters={FilterFromContextFilter}
                        filters={filters}
                        size={"small"}
                        mode={"list"}
                        customRender={render}
                    />}
                </div>
            </td>
        </tr>}
    </React.Fragment>)
}

function AgentskieVoznagrazhdeniya(props) {
    const { auth, eventID } = props;
    // const [tableData, setTableData] = useState()
    const [disabled, setDisabled] = useState(false)
    const [disabled2, setDisabled2] = useState(false)

    const reinit = useCallback((
        collection,
        setCollection, update,
        lock,
        unlock) => {
            update()
    }, [eventID])
  
    const filters = () => [
        {
            name: "vtp.user.lastname",
            sort: true,
            filter: true,
        },
        {
            name: "vtp.user.firstname",
            sort: true,
            filter: true,
        },
        // {
        //     name: "vtp.user.patronymic",
        //     sort: true,
        //     filter: true,
        // },
        // {
        //     name: "vtp.user.email",
        //     sort: true,
        //     filter: true,
        // },
        // {
        //     label: <span>Телефон<span style={{
        //         fontStyle: "italic",
        //         fontSize: "11px",
        //         paddingLeft: "5px",
        //         color: "#818181"
        //     }}>(без +)</span></span>,
        //     name: "vtp.user.phone",
        //     // type: "string",
        //     sort: true,
        //     filter: true,
        // },
        {
            name: "vtp.user.gender",
            sort: true,
            filter: true,
        },
        // {
        //     label: "Тип пользователя",
        //     name: "vtp.tipPolzovatelya",
        //     filterType: "group",
        //     queryFilter: [
        //         QueryDetail("model"),
        //         QueryParam("w-in-id", "18,33,34,35")
        //         // QueryParam("w-neq-id", "7")
        //     ],
        //     display: (o) => o.opisanie,
        //     sort: true,
        //     filter: true,
        // },
        //item?.aktivnost
        // {
        //     label: "Категория",
        //     name: "kategoriya",
        //     source: `/api/meropriyatiya/kategoriiuchastnikovnameropriyatiyakh/list/${eventID}`,
        //     displayString: (item) => {
        //         return item?.tantsevalnayaDistsiplinaPsevdonim + ", " + item?.kategoriyaUchastnikovPsevdonim
        //     },
        //     display: (item) => {
        //         return <CategoryName category={item} style={{
        //             whiteSpace: "nowrap",
        //             overflow: "hidden",
        //             textOverflow: "ellipsis",
        //         }} />
        //     },
        //     queryFilter: [
        //         QueryDetail("model"),
        //         QueryParam("w-meropriyatie", eventID),
        //         QueryOrder("tantsevalnayaDistsiplinaPsevdonim", "ASC"),
        //         QueryOrder("kategoriyaUchastnikovPsevdonim", "ASC")
        //     ],
        //     sort: true,
        //     filter: true
        // },
        {
            label: <FilterFieldLabel label="Промокод" badge="co" color="#919191" background="rgba(216, 216, 216, 0.2)" />,
            name: "promokod.promokod",
            // queryComparer:"swsim", // sim, wsim, swsim
            sort: true,
            filter: true,
        },
        {
            label: "Агентское вознаграждение %",
            name: "agentskoeVoznagrazhdenieProtsent",
            type: "int",
            filterType: "range",
            // func: ["min", "max"],
            min: 0,
            max: 100,
            sort: true,
            filter: true,
        },
        {
            label: "Агентское вознаграждение сумма",
            name: "agentskoeVoznagrazhdenieSumma",
            type: "int",
            filterType: "range",
            func: ["min", "max"],
            sort: true,
            filter: true,
        },
        // {
        //     label: 'Активная',
        //     display: item => item.aktivno, //(item.notActive) ? "Да" : "Нет",
        //     name: "active",
        //     type: "bool",
        //     filter: true
        // },
        // {
        //     label: 'Неактивная',
        //     display: item => !item.aktivno, //(item.notActive) ? "Да" : "Нет",
        //     name: "aktivno",
        //     type: "bool",
        //     filter: true
        // },
        {
            label: "Гонорар расчетный",
            name: "gonorarRaschetnii",
            type: "int",
            filterType: "range",
            func: ["min", "max"],
            sort: true,
            filter: true,
        },
        {
            label: "Гонорар к перечислению",
            name: "summaRaschetnaya",
            type: "int",
            filterType: "range",
            func: ["min", "max"],
            sort: true,
            filter: true,
        },
        {
            label: "Сумма на накопительный",
            name: "summaNaNakopitelnii",
            type: "int",
            filterType: "range",
            func: ["min", "max"],
            sort: true,
            filter: true,
        },
        {
            label: "Сумма на текущий",
            name: "summaNaTekushchii",
            type: "int",
            filterType: "range",
            func: ["min", "max"],
            sort: true,
            filter: true,
        },
    ];

    const render = (items, {
        collection,
        setCollection,
        setCollectionItem,
        removeCollectionItem,
        collectionActions,
        modelActions,
        update,
        lastFuncStat,
        lock,
        unlock,
        loading
    }) => {
        const agentskoeVoznagrazhdenieSumma = lastFuncStat?.agentskoevoznagrazhdeniesumma?.sum || 0;
        const gonorarRaschetnii = lastFuncStat?.gonorarraschetnii?.sum || 0;
        const summaRaschetnaya = lastFuncStat?.summaraschetnaya?.sum || 0;
        const summaNaNakopitelnii = lastFuncStat?.summananakopitelnii?.sum || 0;
        const summaNaTekushchii = lastFuncStat?.summanatekushchii?.sum || 0;

        return (<div>
            <Spin spinning={loading} tip="Загрузка...">
                <div className='bg bg-grey' style={{ display: "flex", justifyContent: "space-between", padding: "3px", marginBottom: "5px" }}>
                    <div style={{ display: "flex", gap: "3px" }}>

                    </div>
                    <div style={{ display: "flex", gap: "3px" }}>
                        <Tooltip title="Обновить значения">
                            <div className={`bg bg-grey pointer`} onClick={() => reinit(collection, setCollection, update, lock, unlock)} style={{ minWidth: "25px", maxWidth: "25px", display: "flex", height: "100%", justifyContent: "center", alignItems: "center" }}>
                                {!loading && <IssuesCloseOutlined />}
                                {loading && <Spin
                                    indicator={
                                        <LoadingOutlined
                                            style={{
                                                color: "grey",
                                                fontSize: 12,
                                            }}
                                            spin
                                        />
                                    }
                                />}
                            </div>
                        </Tooltip>
                    </div>
                </div>
                <div className='scrollable' style={{ backgroundColor: "white" }}>
                    <table className="xtable" style={{ fontSize: "13px", lineHeight: "normal" }}>
                        <thead>
                            <tr>
                                <th className={`fixed height-8`} style={{ minWidth: "25px", backgroundColor: "white" }}>
                                    <div className="bg bg-grey" style={{ minWidth: "25px", backgroundColor: "white" }}></div>
                                </th>
                                <th className={`fixed height-8`} style={{ left: "25px", minWidth: "180px", backgroundColor: "white" }}>
                                    <div className='bg bg-grey dark-1' style={{ minWidth: "unset" }}>Промоутер / артист / куратор / владелец школы</div>
                                </th>
                                <th className="fixed height-8" style={{ left: "205px", minWidth: "200px", backgroundColor: "white" }}>
                                    <div className='bg bg-grey dark-1' style={{ minWidth: "unset" }}>Активность / Категория / Промокод</div>
                                </th>
                                <th className="height-8" style={{ minWidth: "100px", fontWeight: "300" }}>
                                    <div className="bg bg-grey">
                                        Агентское вознаграждение %
                                    </div>
                                </th>
                                <th className="height-8" style={{ minWidth: "100px", fontWeight: "300" }}>
                                    <div className="bg bg-grey">
                                        Агентское вознаграждение сумма
                                    </div>
                                </th>
                                {/* <th className="height-8" style={{ minWidth: "45px", fontWeight: "300" }}>
                                    <div className="bg bg-grey">
                                        Активно
                                    </div>
                                </th> */}
                                <th className="height-8" style={{ minWidth: "100px", fontWeight: "300" }}>
                                    <div className="bg bg-grey">
                                        Гонорар расчетный
                                    </div>
                                </th>
                                <th className="height-8" style={{ minWidth: "100px", fontWeight: "300" }}>
                                    <div className="bg bg-grey">
                                        Гонорар к перечислению
                                    </div>
                                </th>
                                <th className="height-8" style={{ minWidth: "100px", fontWeight: "300" }}>
                                    <div className="bg bg-grey">
                                        Сумма на накопительный
                                    </div>
                                </th>
                                <th className="height-8" style={{ minWidth: "100px", fontWeight: "300" }}>
                                    <div className="bg bg-grey">
                                        Сумма на текущий
                                    </div>
                                </th>
                            </tr>
                            <tr>
                                <th className={`fixed height-4`} style={{ minWidth: "25px", minWidth: "unset" }}>
                                    <div className="bg bg-grey" style={{ minWidth: "25px", backgroundColor: "white" }}></div>
                                </th>
                                <th className={`fixed height-4`} style={{ left: "25px", minWidth: "180px", minWidth: "unset", backgroundColor: "white" }}>
                                    <div className='bg bg-grey dark-1' style={{ minWidth: "unset" }}></div>
                                </th>
                                <th className="fixed height-4" style={{ left: "205px", minWidth: "200px", minWidth: "unset", backgroundColor: "white" }}>
                                    <div className='bg bg-grey dark-1' style={{ minWidth: "unset" }}></div>
                                </th>
                                <th className="height-4" style={{ minWidth: "100px", fontWeight: "300" }}>
                                    <div className="bg bg-grey">

                                    </div>
                                </th>
                                <th className="height-4" style={{ minWidth: "100px", fontWeight: "300" }}>
                                    <div className="bg bg-green" style={{ fontWeight: "bold" }}>
                                        {/* Агентское вознаграждение сумма */}
                                        {(Number(agentskoeVoznagrazhdenieSumma.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })}
                                    </div>
                                </th>
                                {/* <th className="height-4" style={{ minWidth: "45px", fontWeight: "300" }}>
                                    <div className="bg bg-grey">

                                    </div>
                                </th> */}
                                <th className="height-4" style={{ minWidth: "100px", fontWeight: "300" }}>
                                    <div className="bg bg-green" style={{ fontWeight: "bold" }}>
                                        {/* Гонорар расчетный */}
                                        {(Number(gonorarRaschetnii.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })}
                                    </div>
                                </th>
                                <th className="height-4" style={{ minWidth: "100px", fontWeight: "300" }}>
                                    <div className="bg bg-green" style={{ fontWeight: "bold" }}>
                                        {/* Сумма расчетная */}
                                        {(Number(summaRaschetnaya.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })}
                                    </div>
                                </th>
                                <th className="height-4" style={{ minWidth: "100px", fontWeight: "300" }}>
                                    <div className="bg bg-green" style={{ fontWeight: "bold" }}>
                                        {/* Сумма на накопительный */}
                                        {(Number(summaNaNakopitelnii.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })}
                                    </div>
                                </th>
                                <th className="height-4" style={{ minWidth: "100px", fontWeight: "300" }}>
                                    <div className="bg bg-green" style={{ fontWeight: "bold" }}>
                                        {/* Сумма на текущий */}
                                        {(Number(summaNaTekushchii.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })}
                                    </div>
                                </th>
                            </tr>
                        </thead>
                        <tbody style={{ fontSize: "12px" }}>
                            {JSXMap(items || [], (item, cidx) => {
                                return (<AgentskieVoznagrazhdeniyaRow key={cidx} item={item} idx={cidx} eventID={eventID} disabled={disabled} disabled2={disabled2} renderProps={{
                                    collection,
                                    setCollection,
                                    setCollectionItem,
                                    removeCollectionItem,
                                    collectionActions,
                                    modelActions,
                                    update,
                                    lastFuncStat,
                                    lock,
                                    unlock,
                                    loading
                                }} />)
                            })}
                        </tbody>
                    </table>
                </div>
            </Spin>
        </div>)
    }

    const FilterFromContextFilter = React.useCallback(() => [
        QueryParam("f-sum-agentskoeVoznagrazhdenieSumma", 0),
        QueryParam("f-sum-gonorarRaschetnii", 0),
        QueryParam("f-sum-summaRaschetnaya", 0),
        QueryParam("f-sum-summaNaNakopitelnii", 0),
        QueryParam("f-sum-summaNaTekushchii", 0),
    ], [eventID]);

    return (<div>
        <CollectionServer
            auth={auth}
            floatingFilter={true}
            disableScrollTo={true}
            allowFullscreen={true}
            onCollectionChange={(items) => {
                if (items && items.length) {
                    const disabled = items[0]?.meropriyatie?.raschetAgentskikhProizveden;
                    const disabled2 = !disabled || items[0]?.meropriyatie?.dokAgentskikhVoznagrSozdani;
                    setDisabled(disabled)
                    setDisabled2(disabled2)
                }
            }}
            name={"AgentskieVoznagrazhdeniya"}
            // count={() => 10} // !!!! ИСПРАВИТЬ - сделать редактируемым или подобрать нужное количество !!!!
            // queryDetail={"collection"}
            source={`/api/agentskie-voznagrazhdeniya/by-user/page/${eventID}`}
            contextFilters={FilterFromContextFilter}
            filters={filters}
            size={"small"}
            mode={"list"}
            customRender={render}
        />
    </div>)
}

function AgentskieVoznagrazhdeniyaKViplateRow({ item, idx, eventID, disabled, renderProps }) {
    const [collapsed, setCollapsed] = useState(true);
    const auth = useAuth()
    const {
        collection,
        setCollection,
        setCollectionItem,
        removeCollectionItem,
        collectionActions,
        modelActions,
        update,
        lastFuncStat,
        lock,
        unlock,
        loading
    } = renderProps;

    const FilterFromContextFilter = React.useCallback(() => [
        QueryParam("f-sum-agentskoeVoznagrazhdenieSumma", 0),
        QueryParam("f-sum-gonorarRaschetnii", 0),
        QueryParam("f-sum-summaRaschetnaya", 0),
        QueryParam("f-sum-summaNaNakopitelnii", 0),
        QueryParam("f-sum-summaNaTekushchii", 0),
    ], [item, idx, eventID, disabled]);
    const filters = () => [
        {
            name: "vtp.user.lastname",
            sort: true,
            filter: true,
        },
        {
            name: "vtp.user.firstname",
            sort: true,
            filter: true,
        },
        // {
        //     name: "vtp.user.patronymic",
        //     sort: true,
        //     filter: true,
        // },
        // {
        //     name: "vtp.user.email",
        //     sort: true,
        //     filter: true,
        // },
        // {
        //     label: <span>Телефон<span style={{
        //         fontStyle: "italic",
        //         fontSize: "11px",
        //         paddingLeft: "5px",
        //         color: "#818181"
        //     }}>(без +)</span></span>,
        //     name: "vtp.user.phone",
        //     // type: "string",
        //     sort: true,
        //     filter: true,
        // },
        {
            name: "vtp.user.gender",
            sort: true,
            filter: true,
        },
        // {
        //     label: "Тип пользователя",
        //     name: "vtp.tipPolzovatelya",
        //     filterType: "group",
        //     queryFilter: [
        //         QueryDetail("model"),
        //         QueryParam("w-in-id", "18,33,34,35")
        //         // QueryParam("w-neq-id", "7")
        //     ],
        //     display: (o) => o.opisanie,
        //     sort: true,
        //     filter: true,
        // },
        //item?.aktivnost
        // {
        //     label: "Категория",
        //     name: "kategoriya",
        //     source: `/api/meropriyatiya/kategoriiuchastnikovnameropriyatiyakh/list/${eventID}`,
        //     displayString: (item) => {
        //         return item?.tantsevalnayaDistsiplinaPsevdonim + ", " + item?.kategoriyaUchastnikovPsevdonim
        //     },
        //     display: (item) => {
        //         return <CategoryName category={item} style={{
        //             whiteSpace: "nowrap",
        //             overflow: "hidden",
        //             textOverflow: "ellipsis",
        //         }} />
        //     },
        //     queryFilter: [
        //         QueryDetail("model"),
        //         QueryParam("w-meropriyatie", eventID),
        //         QueryOrder("tantsevalnayaDistsiplinaPsevdonim", "ASC"),
        //         QueryOrder("kategoriyaUchastnikovPsevdonim", "ASC")
        //     ],
        //     sort: true,
        //     filter: true
        // },
        {
            label: <FilterFieldLabel label="Промокод" badge="co" color="#919191" background="rgba(216, 216, 216, 0.2)" />,
            name: "promokod.promokod",
            // queryComparer:"swsim", // sim, wsim, swsim
            sort: true,
            filter: true,
        },
        {
            label: "Агентское вознаграждение %",
            name: "agentskoeVoznagrazhdenieProtsent",
            type: "int",
            filterType: "range",
            // func: ["min", "max"],
            min: 0,
            max: 100,
            sort: true,
            filter: true,
        },
        {
            label: "Агентское вознаграждение сумма",
            name: "agentskoeVoznagrazhdenieSumma",
            type: "int",
            filterType: "range",
            func: ["min", "max"],
            sort: true,
            filter: true,
        },
        // {
        //     label: 'Активная',
        //     display: item => item.aktivno, //(item.notActive) ? "Да" : "Нет",
        //     name: "active",
        //     type: "bool",
        //     filter: true
        // },
        // {
        //     label: 'Неактивная',
        //     display: item => !item.aktivno, //(item.notActive) ? "Да" : "Нет",
        //     name: "aktivno",
        //     type: "bool",
        //     filter: true
        // },
        {
            label: "Гонорар расчетный",
            name: "gonorarRaschetnii",
            type: "int",
            filterType: "range",
            func: ["min", "max"],
            sort: true,
            filter: true,
        },
        {
            label: "Сумма расчетная",
            name: "summaRaschetnaya",
            type: "int",
            filterType: "range",
            func: ["min", "max"],
            sort: true,
            filter: true,
        },
        {
            label: "Сумма на накопительный",
            name: "summaNaNakopitelnii",
            type: "int",
            filterType: "range",
            func: ["min", "max"],
            sort: true,
            filter: true,
        },
        {
            label: "Сумма на текущий",
            name: "summaNaTekushchii",
            type: "int",
            filterType: "range",
            func: ["min", "max"],
            sort: true,
            filter: true,
        },
    ];
    const render = (items, {
        collection,
        setCollection,
        setCollectionItem,
        removeCollectionItem,
        collectionActions,
        modelActions,
        update,
        lastFuncStat,
        lock,
        unlock,
        loading
    }) => {
        const agentskoeVoznagrazhdenieSumma = lastFuncStat?.agentskoevoznagrazhdeniesumma?.sum || 0;
        const gonorarRaschetnii = lastFuncStat?.gonorarraschetnii?.sum || 0;
        const summaRaschetnaya = lastFuncStat?.summaraschetnaya?.sum || 0;
        const summaNaNakopitelnii = lastFuncStat?.summananakopitelnii?.sum || 0;
        const summaNaTekushchii = lastFuncStat?.summanatekushchii?.sum || 0;

        return (<div>
            <Spin spinning={loading} tip="Загрузка...">
                <div className='scrollable' style={{}}>
                    <table className="xtable" style={{ fontSize: "13px", lineHeight: "normal" }}>
                        <thead>
                            <tr>
                                {/* <th className={`fixed height-8`} style={{ width: "25px" }}></th> */}
                                <th className={`fixed height-8`} style={{ minWidth: "180px", maxWidth: "180px" }}>
                                    <div className='bg bg-grey dark-1' style={{ minWidth: "unset" }}>Промоутер / артист / куратор / владелец школы</div>
                                </th>
                                <th className="fixed height-8" style={{ left: "180px", minWidth: "180px", maxWidth: "180px" }}>
                                    <div className='bg bg-grey dark-1' style={{ minWidth: "unset" }}>Активность / Категория / Промокод</div>
                                </th>
                                <th className="height-8" style={{ minWidth: "120px", maxWidth: "120px", fontWeight: "300" }}>
                                    <div className="bg bg-grey">
                                        Агентское вознаграждение %
                                    </div>
                                </th>
                                <th className="height-8" style={{ minWidth: "120px", maxWidth: "120px", fontWeight: "300" }}>
                                    <div className="bg bg-grey">
                                        Агентское вознаграждение сумма
                                    </div>
                                </th>
                                {/* <th className="height-8" style={{ minWidth: "45px", maxWidth: "45px", fontWeight: "300" }}>
                                    <div className="bg bg-grey">
                                        Активно
                                    </div>
                                </th> */}
                                <th className="height-8" style={{ minWidth: "100px", maxWidth: "100px", fontWeight: "300" }}>
                                    <div className="bg bg-grey">
                                        Гонорар расчетный
                                    </div>
                                </th>
                                <th className="height-8" style={{ minWidth: "110px", maxWidth: "100px", fontWeight: "300" }}>
                                    <div className="bg bg-grey">
                                        Гонорар к перечислению
                                    </div>
                                </th>
                                <th className="height-8" style={{ minWidth: "110px", maxWidth: "100px", fontWeight: "300" }}>
                                    <div className="bg bg-grey">
                                        Сумма на накопительный
                                    </div>
                                </th>
                                <th className="height-8" style={{ minWidth: "100px", maxWidth: "100px", fontWeight: "300" }}>
                                    <div className="bg bg-grey">
                                        Сумма на текущий
                                    </div>
                                </th>
                            </tr>
                            <tr>
                                {/* <th className={`fixed height-4`} style={{ minWidth: "25px", minWidth: "unset" }}></th> */}
                                <th className={`fixed height-4`} style={{ minWidth: "180px", minWidth: "unset" }}>
                                    <div className='bg bg-grey dark-1' style={{ minWidth: "unset" }}></div>
                                </th>
                                <th className="fixed height-4" style={{ left: "180px", minWidth: "180px", minWidth: "unset" }}>
                                    <div className='bg bg-grey dark-1' style={{ minWidth: "unset" }}></div>
                                </th>
                                <th className="height-4" style={{ minWidth: "120px", fontWeight: "300" }}>
                                    <div className="bg bg-grey">

                                    </div>
                                </th>
                                <th className="height-4" style={{ minWidth: "120px", fontWeight: "300" }}>
                                    <div className="bg bg-green" style={{ fontWeight: "bold" }}>
                                        {/* Агентское вознаграждение сумма */}
                                        {(Number(agentskoeVoznagrazhdenieSumma.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })}
                                    </div>
                                </th>
                                {/* <th className="height-4" style={{ minWidth: "45px", fontWeight: "300" }}>
                                    <div className="bg bg-grey">

                                    </div>
                                </th> */}
                                <th className="height-4" style={{ minWidth: "100px", fontWeight: "300" }}>
                                    <div className="bg bg-green" style={{ fontWeight: "bold" }}>
                                        {/* Гонорар расчетный */}
                                        {(Number(gonorarRaschetnii.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })}
                                    </div>
                                </th>
                                <th className="height-4" style={{ minWidth: "110px", fontWeight: "300" }}>
                                    <div className="bg bg-green" style={{ fontWeight: "bold" }}>
                                        {/* Сумма расчетная */}
                                        {(Number(summaRaschetnaya.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })}
                                    </div>
                                </th>
                                <th className="height-4" style={{ minWidth: "110px", fontWeight: "300" }}>
                                    <div className="bg bg-green" style={{ fontWeight: "bold" }}>
                                        {/* Сумма на накопительный */}
                                        {(Number(summaNaNakopitelnii.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })}
                                    </div>
                                </th>
                                <th className="height-4" style={{ minWidth: "100px", fontWeight: "300" }}>
                                    <div className="bg bg-green" style={{ fontWeight: "bold" }}>
                                        {/* Сумма на текущий */}
                                        {(Number(summaNaTekushchii.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })}
                                    </div>
                                </th>
                            </tr>
                        </thead>
                        <tbody style={{ fontSize: "12px" }}>
                            {JSXMap(items || [], (item, cidx) => {
                                return (<tr key={idx}>
                                    {/* <td className={`fixed pointer height-5`} style={{ minWidth: "25px" }} onClick={() => {
                                        setCollapsed(o => !o);
                                    }}>
                                        <div className={`bg ${(!collapsed) ? "bg-orange dark-5" : "bg-grey"}`} style={{ height: "100%", minWidth: "unset", textAlign: "left", padding: "2px 5px", display: "flex", justifyContent: "center", alignItems: "center", overflow: "hidden" }}>
                                            {(collapsed) && <i className="fa fa-plus-square-o"></i>}
                                            {(!collapsed) && <i className="fa fa-minus-square-o"></i>}
                                        </div>
                                    </td> */}
                                    <td className={`fixed height-5`} style={{ minWidth: "180px" }}>
                                        <div>
                                            <UserName item={item?.vtp?.user} noborder={true} />
                                            <div style={{
                                                color: "rgba(0, 0, 0, 0.45)",
                                                textAlign: "left",
                                                textWrap: "nowrap",
                                                whiteSpace: "nowrap",
                                                overflow: "hidden",
                                                textOverflow: "ellipsis",
                                                fontSize: "12px",
                                                fontWeight: "lighter",
                                                paddingLeft: "20px"
                                            }}>
                                                <span>{item?.vtp?.tipPolzovatelya?.opisanie}</span>
                                            </div>
                                        </div>
                                    </td>
                                    <td className="fixed height-5" style={{ left: "180px", minWidth: "180px" }}>
                                        {item?.aktivnost && <div className='bg bg-grey light-9' style={{ height: "100%", minWidth: "unset", textAlign: "left", padding: "2px 5px", display: "flex", justifyContent: "left", alignItems: "center", overflow: "hidden" }}>
                                            <div style={{
                                                whiteSpace: "nowrap",
                                                overflow: "hidden",
                                                textOverflow: "ellipsis",
                                            }}>
                                                <div style={{
                                                    color: "rgba(0, 0, 0, 0.45)",
                                                    textAlign: "left",
                                                    textWrap: "nowrap",
                                                    whiteSpace: "nowrap",
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                    fontSize: "12px",
                                                    fontWeight: "lighter"
                                                }}>
                                                    Активность
                                                </div>
                                                <div style={{
                                                    whiteSpace: "nowrap",
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                }}>{item?.aktivnost?.nazvanie}</div>
                                            </div>
                                        </div>}
                                        {item?.kategoriya && <div className='bg bg-grey light-9' style={{ height: "100%", minWidth: "unset", textAlign: "left", padding: "2px 5px", display: "flex", justifyContent: "left", alignItems: "center", overflow: "hidden" }}>
                                            <div style={{
                                                whiteSpace: "nowrap",
                                                overflow: "hidden",
                                                textOverflow: "ellipsis",
                                            }}>
                                                <div style={{
                                                    color: "rgba(0, 0, 0, 0.45)",
                                                    textAlign: "left",
                                                    textWrap: "nowrap",
                                                    whiteSpace: "nowrap",
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                    fontSize: "12px",
                                                    fontWeight: "lighter"
                                                }}>
                                                    Категория
                                                </div>
                                                <CategoryName category={item?.kategoriya} style={{
                                                    whiteSpace: "nowrap",
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                }} />
                                            </div>
                                        </div>}
                                        {item?.promokod && <div className='bg bg-grey light-9' style={{ height: "100%", minWidth: "unset", textAlign: "left", padding: "2px 5px", display: "flex", justifyContent: "left", alignItems: "center", overflow: "hidden" }}>
                                            <div style={{
                                                whiteSpace: "nowrap",
                                                overflow: "hidden",
                                                textOverflow: "ellipsis",
                                            }}>
                                                <div style={{
                                                    color: "rgba(0, 0, 0, 0.45)",
                                                    textAlign: "left",
                                                    textWrap: "nowrap",
                                                    whiteSpace: "nowrap",
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                    fontSize: "12px",
                                                    fontWeight: "lighter"
                                                }}>
                                                    Промокод
                                                </div>
                                                <div style={{
                                                    whiteSpace: "nowrap",
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                }}>{item?.promokod?.promokod}</div>
                                            </div>
                                        </div>}
                                        {(!item?.aktivnost && !item?.kategoriya && !item?.promokod) && <div className='bg bg-grey light-9' style={{ height: "100%", minWidth: "unset", padding: "2px 5px", display: "flex", justifyContent: "left", alignItems: "center", overflow: "hidden" }}>
                                            <div>

                                            </div>
                                        </div>}
                                    </td>
                                    <td className="height-5" style={{ minWidth: "120px" }}>
                                        <div className="bg bg-grey dark-1 border-transparent" style={{ height: "100%", padding: "2px 5px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                                            <div>
                                                {(Number(item?.agentskoeVoznagrazhdenieProtsent?.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })}
                                            </div>
                                        </div>
                                    </td>
                                    <td className="height-5" style={{ minWidth: "120px" }}>
                                        <div className="bg bg-grey dark-1 border-transparent" style={{ height: "100%", padding: "2px 5px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                                            <div>
                                                {(Number(item?.agentskoeVoznagrazhdenieSumma?.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })}
                                            </div>
                                        </div>
                                    </td>
                                    {/* <td className="height-5" style={{ minWidth: "100px" }}>
                                        <div className="bg bg-grey dark-1 border-transparent" style={{ height: "100%", padding: "2px 5px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                                            <div>{(item?.aktivno) ? "Да" : "Нет"}</div>
                                        </div>
                                    </td> */}

                                    <td className="height-5" style={{ minWidth: "100px" }}>
                                        <div className="bg bg-orange dark-1 border-transparent" style={{ height: "100%", padding: "2px 5px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                                            <div>
                                                {(Number(item?.gonorarRaschetnii?.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })}
                                            </div>
                                        </div>
                                    </td>
                                    <td className="height-5" style={{ minWidth: "110px" }}>
                                        <div className="bg bg-grey dark-1 border-transparent" style={{ height: "100%", padding: "2px 5px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                                            <div>
                                                {(Number(item?.summaRaschetnaya?.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })}
                                            </div>
                                        </div>
                                    </td>
                                    <td className="height-5" style={{ minWidth: "110px" }}>
                                        <div className="bg bg-grey dark-1 border-transparent" style={{ height: "100%", padding: "2px 5px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                                            <div>
                                                {(Number(item?.summaNaNakopitelnii?.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })}
                                            </div>
                                        </div>
                                    </td>
                                    <td className="height-5" style={{ minWidth: "100px" }}>
                                        <div className="bg bg-grey dark-1 border-transparent" style={{ height: "100%", padding: "2px 5px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                                            <div>
                                                {(Number(item?.summaNaTekushchii?.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })}
                                            </div>
                                        </div>
                                    </td>
                                </tr>)
                            })}
                        </tbody>
                    </table>
                </div>
            </Spin>
        </div>)
    }
    return (<React.Fragment key={idx + "wrap"}>
        <tr key={idx}>
            <td className={`fixed pointer height-5`} style={{ minWidth: "25px", backgroundColor: "white" }} onClick={() => {
                setCollapsed(o => !o);
            }}>
                <div className={`bg ${(!collapsed) ? "bg-orange dark-5" : "bg-grey"}`} style={{ height: "100%", minWidth: "unset", textAlign: "left", padding: "2px 5px", display: "flex", justifyContent: "center", alignItems: "center", overflow: "hidden" }}>
                    {(collapsed) && <i className="fa fa-plus-square-o"></i>}
                    {(!collapsed) && <i className="fa fa-minus-square-o"></i>}
                </div>
            </td>
            <td className={`fixed height-4`} style={{ left: "25px", minWidth: "180px", backgroundColor: "white" }}>
                <div style={{ padding: "2px 0px" }}>
                    <UserName item={item?.polzovatel} noborder={true} />
                </div>
            </td>
            <td className="height-4" style={{ minWidth: "100px", backgroundColor: "white" }}>
                <div className="bg bg-orange dark-1 border-transparent" style={{ height: "100%", padding: "2px 5px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <div>
                        {/* Общее расчетное вознаграждение */}
                        {(Number(item?.obshcheeRaschetnoeVoznagrazhdenie?.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })}
                    </div>
                </div>
            </td>
            <td className="height-4" style={{ minWidth: "100px", backgroundColor: "white" }}>
                <div className="bg bg-orange dark-1 border-transparent" style={{ height: "100%", padding: "2px 5px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <div>
                        {/* Общее расчетное (НЕ Промоутер) */}
                        {(Number(item?.summaRaschetnayaNePromouter?.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })}
                    </div>
                </div>
            </td>
            <td className="height-4" style={{ minWidth: "100px", backgroundColor: "white" }}>
                <div className="bg bg-orange dark-1 border-transparent" style={{ height: "100%", padding: "2px 5px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <div>
                        {/* Сумма на накопительный (НЕ Промоутер) */}
                        {(Number(item?.summaNaNakopitelniiNePromouter?.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })}
                    </div>
                </div>
            </td>
            <td className="height-4" style={{ minWidth: "100px", backgroundColor: "white" }}>
                <div className="bg bg-orange dark-1 border-transparent" style={{ height: "100%", padding: "2px 5px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <div>
                        {/*  Сумма на текущий (НЕ Промоутер) */}
                        {(Number(item?.summaNaTekushchiiNePromouter?.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })}
                    </div>
                </div>
            </td>
            <td className="height-4" style={{ minWidth: "100px", backgroundColor: "white" }}>
                <div className="bg bg-orange dark-1 border-transparent" style={{ height: "100%", padding: "2px 5px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <div>
                        {/* Оборот по промоутерству */}
                        {(Number(item?.oborotPoPromouterstvu?.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })}
                    </div>
                </div>
            </td>
            <td className="height-4" style={{ minWidth: "100px", backgroundColor: "white" }}>
                <div className="bg bg-orange dark-1 border-transparent" style={{ height: "100%", padding: "2px 5px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <div>
                        {/* Сумма расчетная (Промоутер) */}
                        {(Number(item?.summaRaschetnayaPromouter?.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })}
                    </div>
                </div>
            </td>
            <td className="height-4" style={{ minWidth: "100px", backgroundColor: "white" }}>
                <div className="bg bg-orange dark-1 border-transparent" style={{ height: "100%", padding: "2px 5px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <div>
                        {/* Сумма на накопительный (Промоутер) */}
                        {(Number(item?.summaNaNakopitelniiPromouter?.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })}
                    </div>
                </div>
            </td>
            <td className="height-4" style={{ minWidth: "100px", backgroundColor: "white" }}>
                <div className="bg bg-orange dark-1 border-transparent" style={{ height: "100%", padding: "2px 5px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <div>
                        {/* Сумма на текущий (Промоутер) */}
                        {(Number(item?.summaNaTekushchiiPromouter?.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })}
                    </div>
                </div>
            </td>
            <td className="height-4" style={{ minWidth: "100px", backgroundColor: "white" }}>
                {/* ! Гонорар как приглашенный артист */}
                <div className="bg bg-blue dark-1 border-transparent" style={{ height: "100%", padding: "2px 5px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <div>
                        {(Number(item?.gonorarPriglashennogoArtista?.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })}
                    </div>
                </div>

            </td>
            <td className="height-4" style={{ minWidth: "100px", backgroundColor: "white" }}>
                {/* ! Доп затраты на промоутера */}
                <div className="bg bg-blue dark-1 border-transparent" style={{ height: "100%", padding: "2px 5px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <div>
                        {(Number(item?.dopZatratiNaPromoutera?.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })}
                    </div>
                </div>
            </td>
            <td className="height-4" style={{ minWidth: "100px", backgroundColor: "white" }}>
                {/* ! Процент рентабельности */}
                <div className="bg bg-blue dark-1 border-transparent" style={{ height: "100%", padding: "2px 5px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <div>
                        {(Number(item?.protsentRentabelnosti?.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })}
                    </div>
                </div>
            </td>
            <td className="height-4" style={{ minWidth: "100px", backgroundColor: "white" }}>
                <div className="bg bg-orange dark-1 border-transparent" style={{ height: "100%", padding: "2px 5px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <div>
                        {/* База для расчета промоутерства */}
                        {(Number(item?.bazaDlyaRaschetaPromouterstva?.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })}
                    </div>
                </div>
            </td>
            <td className="height-4" style={{ minWidth: "100px", backgroundColor: "white" }}>
                <div className="bg bg-orange dark-1 border-transparent" style={{ height: "100%", padding: "2px 5px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <div>
                        {/*  К выплате гонорар как приглашенный (Артист) */}
                        {(Number(item?.kViplateGonorarKakPriglashenniiArtist?.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })}
                    </div>
                </div>
            </td>
            <td className="height-4" style={{ minWidth: "100px", backgroundColor: "white" }}>
                <div className="bg bg-orange dark-1 border-transparent" style={{ height: "100%", padding: "2px 5px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <div>
                        {/*  Общее вознаграждение к выплате (Промоутер) */}
                        {(Number(item?.obshcheeVoznagrazhdenieKViplatePromouter?.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })}
                    </div>
                </div>
            </td>
            <td className="height-4" style={{ minWidth: "100px", backgroundColor: "white" }}>
                {/* ! К выплате на накопительный счет */}
                <div className="bg bg-blue dark-1 border-transparent" style={{ height: "100%", padding: "2px 5px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <div>
                        {(Number(item?.kViplateNaNakopitelniiSchet?.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })}
                    </div>
                </div>
            </td>
            <td className="height-4" style={{ minWidth: "100px", backgroundColor: "white" }}>
                {/* ! К выплате на текущий счет */}
                <div className="bg bg-blue dark-1 border-transparent" style={{ height: "100%", padding: "2px 5px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <div>
                        {(Number(item?.kViplateNaTekushchiiSchet?.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })}
                    </div>
                </div>
            </td>
            <td className="height-4" style={{ minWidth: "100px", backgroundColor: "white" }}>
                {/* Проводка на накопительный*/}
                <div className="bg bg-blue dark-1 border-transparent" style={{ height: "100%", padding: "2px 5px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <div>
                        {(Number(item?.provodkaNaNakopitelnii?.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })}
                    </div>
                </div>
            </td>
            <td className="height-4" style={{ minWidth: "100px", backgroundColor: "white" }}>
                {/*  Проводка на текущий*/}
                <div className="bg bg-blue dark-1 border-transparent" style={{ height: "100%", padding: "2px 5px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <div>
                        {(Number(item?.provodkaNaTekushchii?.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })}
                    </div>
                </div>
            </td>
            <td className="height-4" style={{ minWidth: "250px", maxWidth: "250px", backgroundColor: "white" }}>
            <div className="bg bg-grey border-transparent" style={{ height: "100%", padding: "2px 5px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <div>
                        {item?.kommentarii}
                    </div>
                </div>
            </td>
        </tr>
        {(!collapsed) && <tr key={idx + "ext"}>
            <td colSpan={21}>
                <div className="bg bg-orange border-grey" style={{ borderColor: "darkgrey", textAlign: "left", marginLeft: "25px", paddingTop: "10px", marginTop: "5px", marginBottom: "5px" }}>
                    {item && <CollectionServer
                        auth={auth}
                        floatingFilter={true}
                        disableScrollTo={true}
                        headerStyle={{ flexDirection: "row-reverse" }}
                        footerStyle={{ flexDirection: "row-reverse" }}
                        filterPopoverPlacement="bottomLeft"
                        // onCollectionChange={(items) => {
                        //     if (items && items.length) {
                        //         const disabled = items[0]?.meropriyatie?.raschetAgentskikhProizveden;
                        //         const disabled2 = !disabled || items[0]?.meropriyatie?.dokAgentskikhVoznagrSozdani;
                        //         setDisabled(disabled)
                        //         setDisabled2(disabled2)
                        //     }
                        // }}
                        name={"AgentskieVoznagrazhdeniya"}
                        count={() => 10} // !!!! ИСПРАВИТЬ - сделать редактируемым или подобрать нужное количество !!!!
                        // queryDetail={"collection"}
                        source={`/api/agentskie-voznagrazhdeniya-k-viplate/by-user/agentskie-voznagrazhdeniya/page/${item?.ID}`}
                        contextFilters={FilterFromContextFilter}
                        filters={filters}
                        size={"small"}
                        mode={"list"}
                        customRender={render}
                    />}
                </div>
            </td>
        </tr>}
    </React.Fragment>)
}

function AgentskieVoznagrazhdeniyaKViplate(props) {
    const { auth, eventID } = props;

    const reinit = useCallback((
        collection,
        setCollection, update,
        lock,
        unlock) => {
            update()
    }, [eventID])

    const filters = () => [
        {
            name: "polzovatel.lastname",
            sort: true,
            filter: true,
        },
        {
            name: "polzovatel.firstname",
            sort: true,
            filter: true,
        },
        // {
        //     name: "polzovatel.patronymic",
        //     sort: true,
        //     filter: true,
        // },
        // {
        //     name: "polzovatel.email",
        //     sort: true,
        //     filter: true,
        // },
        // {
        //     label: <span>Телефон<span style={{
        //         fontStyle: "italic",
        //         fontSize: "11px",
        //         paddingLeft: "5px",
        //         color: "#818181"
        //     }}>(без +)</span></span>,
        //     name: "polzovatel.phone",
        //     // type: "string",
        //     sort: true,
        //     filter: true,
        // },
        {
            name: "polzovatel.gender",
            sort: true,
            filter: true,
        },
        {
            label: "Общее расчетное вознаграждение",
            name: "obshcheeRaschetnoeVoznagrazhdenie",
            type: "int",
            filterType: "range",
            func: ["min", "max"],
            //min: 0,
            //max: 100,
            sort: true,
            filter: true,
        },
        {
            label: (<div>
                <div>Общее расчетное</div>
                <div style={{
                    fontStyle: "italic",
                    fontSize: "11px",
                    color: "#818181"
                }}>(НЕ Промоутер)</div>
            </div>),
            name: "summaRaschetnayaNePromouter",
            type: "int",
            filterType: "range",
            func: ["min", "max"],
            sort: true,
            filter: true,
        },
        {
            label: (<div>
                <div>Сумма на накопительный</div>
                <div style={{
                    fontStyle: "italic",
                    fontSize: "11px",
                    color: "#818181"
                }}>(НЕ Промоутер)</div>
            </div>),
            // label: "Сумма на накопительный (НЕ Промоутер)",
            name: "summaNaNakopitelniiNePromouter",
            type: "int",
            filterType: "range",
            func: ["min", "max"],
            sort: true,
            filter: true,
        },
        {
            label: (<div>
                <div>Сумма на текущий</div>
                <div style={{
                    fontStyle: "italic",
                    fontSize: "11px",
                    color: "#818181"
                }}>(НЕ Промоутер)</div>
            </div>),
            // label: "Сумма на текущий (НЕ Промоутер)",
            name: "summaNaTekushchiiNePromouter",
            type: "int",
            filterType: "range",
            func: ["min", "max"],
            sort: true,
            filter: true,
        },
        {
            label: "Оборот по промоутерству",
            name: "oborotPoPromouterstvu",
            type: "int",
            filterType: "range",
            func: ["min", "max"],
            sort: true,
            filter: true,
        },
        {
            label: (<div>
                <div>Сумма расчетная</div>
                <div style={{
                    fontStyle: "italic",
                    fontSize: "11px",
                    color: "#818181"
                }}>(Промоутер)</div>
            </div>),
            // label: "Сумма расчетная (Промоутер)",
            name: "summaRaschetnayaPromouter",
            type: "int",
            filterType: "range",
            func: ["min", "max"],
            sort: true,
            filter: true,
        },
        {
            label: (<div>
                <div>Сумма на накопительный</div>
                <div style={{
                    fontStyle: "italic",
                    fontSize: "11px",
                    color: "#818181"
                }}>(Промоутер)</div>
            </div>),
            // label: "Сумма на накопительный (Промоутер)",
            name: "summaNaNakopitelniiPromouter",
            type: "int",
            filterType: "range",
            func: ["min", "max"],
            sort: true,
            filter: true,
        },
        {
            label: (<div>
                <div>Сумма на текущий</div>
                <div style={{
                    fontStyle: "italic",
                    fontSize: "11px",
                    color: "#818181"
                }}>(Промоутер)</div>
            </div>),
            // label: "Сумма на текущий (Промоутер)",
            name: "summaNaTekushchiiPromouter",
            type: "int",
            filterType: "range",
            func: ["min", "max"],
            sort: true,
            filter: true,
        },
        {
            label: "Гонорар как приглашенный артист",
            name: "gonorarPriglashennogoArtista",
            type: "int",
            filterType: "range",
            func: ["min", "max"],
            //min: 0,
            //max: 100,
            sort: true,
            filter: true,
        },
        {
            label: "Доп затраты на промоутера",
            name: "dopZatratiNaPromoutera",
            type: "int",
            filterType: "range",
            func: ["min", "max"],
            sort: true,
            filter: true,
        },
        {
            label: "Процент рентабельности",
            name: "protsentRentabelnosti",
            type: "int",
            filterType: "range",
            // func: ["min", "max"],
            min: 0,
            max: 100,
            sort: true,
            filter: true,
        },
        {
            label: (<div>
                <div>К выплате гонорар как приглашенный</div>
                <div style={{
                    fontStyle: "italic",
                    fontSize: "11px",
                    color: "#818181"
                }}>(Артист)</div>
            </div>),
            // label: "К выплате гонорар как приглашенный (Артист)",
            name: "kViplateGonorarKakPriglashenniiArtist",
            type: "int",
            filterType: "range",
            func: ["min", "max"],
            sort: true,
            filter: true,
        },
        {
            label: (<div>
                <div>Общее вознаграждение к выплате</div>
                <div style={{
                    fontStyle: "italic",
                    fontSize: "11px",
                    color: "#818181"
                }}>(Промоутер)</div>
            </div>),
            // label: "Общее вознаграждение к выплате (Промоутер)",
            name: "obshcheeVoznagrazhdenieKViplatePromouter",
            type: "int",
            filterType: "range",
            func: ["min", "max"],
            sort: true,
            filter: true,
        },
        {
            label: "К выплате на накопительный счет",
            name: "kViplateNaNakopitelniiSchet",
            type: "int",
            filterType: "range",
            func: ["min", "max"],
            sort: true,
            filter: true,
        },
        {
            label: "К выплате на текущий счет",
            name: "kViplateNaTekushchiiSchet",
            type: "int",
            filterType: "range",
            func: ["min", "max"],
            sort: true,
            filter: true,
        },
        {
            label: "Проводка на накопительный",
            name: "provodkaNaNakopitelnii",
            type: "int",
            filterType: "range",
            func: ["min", "max"],
            sort: true,
            filter: true,
        },
        {
            label: "Проводка на текущий",
            name: "provodkaNaTekushchii",
            type: "int",
            filterType: "range",
            func: ["min", "max"],
            sort: true,
            filter: true,
        },
    ];

    const render = (items, {
        collection,
        setCollection,
        setCollectionItem,
        removeCollectionItem,
        collectionActions,
        modelActions,
        update,
        lastFuncStat,
        lock,
        unlock,
        loading
    }) => {
        const obshcheeRaschetnoeVoznagrazhdenie = lastFuncStat?.obshcheeraschetnoevoznagrazhdenie?.sum || 0;
        const summaRaschetnayaNePromouter = lastFuncStat?.summaraschetnayanepromouter?.sum || 0;
        const summaNaNakopitelniiNePromouter = lastFuncStat?.summananakopitelniinepromouter?.sum || 0;
        const summaNaTekushchiiNePromouter = lastFuncStat?.summanatekushchiinepromouter?.sum || 0;
        const oborotPoPromouterstvu = lastFuncStat?.oborotpopromouterstvu?.sum || 0;
        const summaRaschetnayaPromouter = lastFuncStat?.summaraschetnayapromouter?.sum || 0;
        const summaNaNakopitelniiPromouter = lastFuncStat?.summananakopitelniipromouter?.sum || 0;
        const summaNaTekushchiiPromouter = lastFuncStat?.summanatekushchiipromouter?.sum || 0;
        const gonorarPriglashennogoArtista = lastFuncStat?.gonorarpriglashennogoartista?.sum || 0;
        const dopZatratiNaPromoutera = lastFuncStat?.dopzatratinapromoutera?.sum || 0;
        const kViplateGonorarKakPriglashenniiArtist = lastFuncStat?.kviplategonorarkakpriglashenniiartist?.sum || 0;
        const obshcheeVoznagrazhdenieKViplatePromouter = lastFuncStat?.obshcheevoznagrazhdeniekviplatepromouter?.sum || 0;
        const kViplateNaNakopitelniiSchet = lastFuncStat?.kviplatenanakopitelniischet?.sum || 0;
        const kViplateNaTekushchiiSchet = lastFuncStat?.kviplatenatekushchiischet?.sum || 0;
        const provodkaNaNakopitelnii = lastFuncStat?.provodkananakopitelnii?.sum || 0;
        const provodkaNaTekushchii = lastFuncStat?.provodkanatekushchii?.sum || 0;

        return (<div>
            <Spin spinning={loading} tip="Загрузка...">
                <div className='bg bg-grey' style={{ display: "flex", justifyContent: "space-between", padding: "3px", marginBottom: "5px" }}>
                    <div style={{ display: "flex", gap: "3px" }}>

                    </div>
                    <div style={{ display: "flex", gap: "3px" }}>
                        <Tooltip title="Обновить значения">
                            <div className={`bg bg-grey pointer`} onClick={() => reinit(collection, setCollection, update, lock, unlock)} style={{ minWidth: "25px", maxWidth: "25px", display: "flex", height: "100%", justifyContent: "center", alignItems: "center" }}>
                                {!loading && <IssuesCloseOutlined />}
                                {loading && <Spin
                                    indicator={
                                        <LoadingOutlined
                                            style={{
                                                color: "grey",
                                                fontSize: 12,
                                            }}
                                            spin
                                        />
                                    }
                                />}
                            </div>
                        </Tooltip>
                    </div>
                </div>
                <div className='scrollable' style={{ backgroundColor: "white" }}>
                    <table className="xtable" style={{ fontSize: "13px", lineHeight: "normal" }}>
                        <thead>
                            <tr style={{ backgroundColor: "white" }}>
                                <th className={`fixed height-10`} style={{ minWidth: "25px", backgroundColor: "white" }}>
                                    <div className="bg bg-grey" style={{ minWidth: "25px", backgroundColor: "white" }}></div>
                                </th>
                                <th className={`fixed height-10`} style={{ left: "25px", minWidth: "180px", backgroundColor: "white" }}>
                                    <div className='bg bg-grey dark-1'>Пользователь</div>
                                </th>
                                <th className="height-10" style={{ minWidth: "100px", fontWeight: "300" }}>
                                    <div className="bg bg-grey">
                                        Общее расчетное вознаграждение
                                    </div>
                                </th>
                                <th className="height-10" style={{ minWidth: "100px", fontWeight: "300" }}>
                                    <div className="bg bg-grey">
                                        {/* Общее расчетное (НЕ Промоутер) */}
                                        <div>
                                            <div>Общее расчетное</div>
                                            <div style={{
                                                fontStyle: "italic",
                                                fontSize: "11px",
                                                color: "#818181"
                                            }}>(НЕ Промоутер)</div>
                                        </div>
                                    </div>
                                </th>
                                <th className="height-10" style={{ minWidth: "100px", fontWeight: "300" }}>
                                    <div className="bg bg-grey">
                                        <div>
                                            <div>Сумма на накопительный</div>
                                            <div style={{
                                                fontStyle: "italic",
                                                fontSize: "11px",
                                                color: "#818181"
                                            }}>(НЕ Промоутер)</div>
                                        </div>
                                    </div>
                                </th>
                                <th className="height-10" style={{ minWidth: "100px", fontWeight: "300" }}>
                                    <div className="bg bg-grey">
                                        <div>
                                            <div>Сумма на текущий</div>
                                            <div style={{
                                                fontStyle: "italic",
                                                fontSize: "11px",
                                                color: "#818181"
                                            }}>(НЕ Промоутер)</div>
                                        </div>
                                    </div>
                                </th>
                                <th className="height-10" style={{ minWidth: "100px", fontWeight: "300" }}>
                                    <div className="bg bg-grey">
                                        Оборот по промоутерству
                                    </div>
                                </th>
                                <th className="height-10" style={{ minWidth: "100px", fontWeight: "300" }}>
                                    <div className="bg bg-grey">
                                        {/* Сумма расчетная (Промоутер) */}
                                        <div>
                                            <div>Сумма расчетная</div>
                                            <div style={{
                                                fontStyle: "italic",
                                                fontSize: "11px",
                                                color: "#818181"
                                            }}>(Промоутер)</div>
                                        </div>
                                    </div>
                                </th>
                                <th className="height-10" style={{ minWidth: "100px", fontWeight: "300" }}>
                                    <div className="bg bg-grey">
                                        {/* Сумма на накопительный (Промоутер) */}
                                        <div>
                                            <div>Сумма на накопительный</div>
                                            <div style={{
                                                fontStyle: "italic",
                                                fontSize: "11px",
                                                color: "#818181"
                                            }}>(Промоутер)</div>
                                        </div>
                                    </div>
                                </th>
                                <th className="height-10" style={{ minWidth: "100px", fontWeight: "300" }}>
                                    <div className="bg bg-grey">
                                        {/* Сумма на текущий (Промоутер) */}
                                        <div>
                                            <div>Сумма на текущий</div>
                                            <div style={{
                                                fontStyle: "italic",
                                                fontSize: "11px",
                                                color: "#818181"
                                            }}>(Промоутер)</div>
                                        </div>
                                    </div>
                                </th>
                                <th className="height-10" style={{ minWidth: "100px", fontWeight: "300" }}>
                                    <div className="bg bg-grey">
                                        Гонорар как приглашенный артист
                                    </div>
                                </th>
                                <th className="height-10" style={{ minWidth: "100px", fontWeight: "300" }}>
                                    <div className="bg bg-grey">
                                        Доп затраты на промоутера
                                    </div>
                                </th>
                                <th className="height-10" style={{ minWidth: "100px", fontWeight: "300" }}>
                                    <div className="bg bg-grey">
                                        Процент рентабельности
                                    </div>
                                </th>
                                <th className="height-10" style={{ minWidth: "100px", fontWeight: "300" }}>
                                    <div className="bg bg-grey">
                                        База для расчета промоутерства
                                    </div>
                                </th>
                                <th className="height-10" style={{ minWidth: "100px", fontWeight: "300" }}>
                                    <div className="bg bg-grey">
                                        {/* К выплате гонорар как приглашенный (Артист) */}
                                        <div>
                                            <div>К выплате гонорар как приглашенный</div>
                                            <div style={{
                                                fontStyle: "italic",
                                                fontSize: "11px",
                                                color: "#818181"
                                            }}>(Артист)</div>
                                        </div>
                                    </div>
                                </th>
                                <th className="height-10" style={{ minWidth: "100px", fontWeight: "300" }}>
                                    <div className="bg bg-grey">
                                        {/* Общее вознаграждение к выплате (Промоутер) */}
                                        <div>
                                            <div>Общее вознаграждение к выплате</div>
                                            <div style={{
                                                fontStyle: "italic",
                                                fontSize: "11px",
                                                color: "#818181"
                                            }}>(Промоутер)</div>
                                        </div>
                                    </div>
                                </th>
                                <th className="height-10" style={{ minWidth: "100px", fontWeight: "300" }}>
                                    <div className="bg bg-grey">
                                        К выплате на накопительный счет
                                    </div>
                                </th>
                                <th className="height-10" style={{ minWidth: "100px", fontWeight: "300" }}>
                                    <div className="bg bg-grey">
                                        К выплате на текущий счет
                                    </div>
                                </th>
                                <th className="height-10" style={{ minWidth: "100px", fontWeight: "300" }}>
                                    <div className="bg bg-grey">
                                        Проводка на накопительный
                                    </div>
                                </th>
                                <th className="height-10" style={{ minWidth: "100px", fontWeight: "300" }}>
                                    <div className="bg bg-grey">
                                        Проводка на текущий
                                    </div>
                                </th>
                                <th className="height-10" style={{ minWidth: "200px", fontWeight: "300" }}>
                                    <div className="bg bg-grey">
                                        Комментарий
                                    </div>
                                </th>
                            </tr>
                            <tr>
                                <th className={`fixed height-4`} style={{ minWidth: "25px", minWidth: "unset", backgroundColor: "white" }}>
                                    <div className="bg bg-grey" style={{ minWidth: "25px", backgroundColor: "white" }}></div>
                                </th>
                                <th className={`fixed height-4`} style={{ left: "25px", minWidth: "180px", backgroundColor: "white" }}>
                                    <div className='bg bg-grey dark-1'>
                                        {/* Пользователь */}
                                    </div>
                                </th>
                                <th className="height-4" style={{ minWidth: "100px", fontWeight: "300" }}>
                                    <div className="bg bg-green" style={{ fontWeight: "bold" }}>
                                        {/* Общее расчетное вознаграждение */}
                                        {(Number(obshcheeRaschetnoeVoznagrazhdenie.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })}
                                    </div>
                                </th>
                                <th className="height-4" style={{ minWidth: "100px", fontWeight: "300" }}>
                                    <div className="bg bg-green" style={{ fontWeight: "bold" }}>
                                        {/* Общее расчетное (НЕ Промоутер) */}
                                        {(Number(summaRaschetnayaNePromouter.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })}
                                    </div>
                                </th>
                                <th className="height-4" style={{ minWidth: "100px", fontWeight: "300" }}>
                                    <div className="bg bg-green" style={{ fontWeight: "bold" }}>
                                        {/* Сумма на накопительный (НЕ Промоутер) */}
                                        {(Number(summaNaNakopitelniiNePromouter.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })}
                                    </div>
                                </th>
                                <th className="height-4" style={{ minWidth: "100px", fontWeight: "300" }}>
                                    <div className="bg bg-green" style={{ fontWeight: "bold" }}>
                                        {/* Сумма на текущий (НЕ Промоутер) */}
                                        {(Number(summaNaTekushchiiNePromouter.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })}
                                    </div>
                                </th>
                                <th className="height-4" style={{ minWidth: "100px", fontWeight: "300" }}>
                                    <div className="bg bg-green" style={{ fontWeight: "bold" }}>
                                        {/* Оборот по промоутерству */}
                                        {(Number(oborotPoPromouterstvu.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })}
                                    </div>
                                </th>
                                <th className="height-4" style={{ minWidth: "100px", fontWeight: "300" }}>
                                    <div className="bg bg-green" style={{ fontWeight: "bold" }}>
                                        {/* Сумма расчетная (Промоутер) */}
                                        {(Number(summaRaschetnayaPromouter.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })}
                                    </div>
                                </th>
                                <th className="height-4" style={{ minWidth: "100px", fontWeight: "300" }}>
                                    <div className="bg bg-green" style={{ fontWeight: "bold" }}>
                                        {/* Сумма на накопительный (Промоутер) */}
                                        {(Number(summaNaNakopitelniiPromouter.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })}
                                    </div>
                                </th>
                                <th className="height-4" style={{ minWidth: "100px", fontWeight: "300" }}>
                                    <div className="bg bg-green" style={{ fontWeight: "bold" }}>
                                        {/* Сумма на текущий (Промоутер) */}
                                        {(Number(summaNaTekushchiiPromouter.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })}
                                    </div>
                                </th>
                                <th className="height-4" style={{ minWidth: "100px", fontWeight: "300" }}>
                                    <div className="bg bg-green" style={{ fontWeight: "bold" }}>
                                        {/* Гонорар как приглашенный артист */}
                                        {(Number(gonorarPriglashennogoArtista.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })}
                                    </div>
                                </th>
                                <th className="height-4" style={{ minWidth: "100px", fontWeight: "300" }}>
                                    <div className="bg bg-green" style={{ fontWeight: "bold" }}>
                                        {/* Доп затраты на промоутера */}
                                        {(Number(dopZatratiNaPromoutera.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })}
                                    </div>
                                </th>
                                <th className="height-4" style={{ minWidth: "100px", fontWeight: "300" }}>
                                    <div className="bg bg-grey">
                                        {/* Процент рентабельности */}
                                    </div>
                                </th>
                                <th className="height-4" style={{ minWidth: "100px", fontWeight: "300" }}>
                                    <div className="bg bg-grey">
                                        {/* База для расчета промоутерства */}
                                    </div>
                                </th>
                                <th className="height-4" style={{ minWidth: "100px", fontWeight: "300" }}>
                                    <div className="bg bg-green" style={{ fontWeight: "bold" }}>
                                        {/* К выплате гонорар как приглашенный (Артист) */}
                                        {(Number(kViplateGonorarKakPriglashenniiArtist.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })}
                                    </div>
                                </th>
                                <th className="height-4" style={{ minWidth: "100px", fontWeight: "300" }}>
                                    <div className="bg bg-green" style={{ fontWeight: "bold" }}>
                                        {/* Общее вознаграждение к выплате (Промоутер) */}
                                        {(Number(obshcheeVoznagrazhdenieKViplatePromouter.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })}
                                    </div>
                                </th>
                                <th className="height-4" style={{ minWidth: "100px", fontWeight: "300" }}>
                                    <div className="bg bg-green" style={{ fontWeight: "bold" }}>
                                        {/* К выплате на накопительный счет */}
                                        {(Number(kViplateNaNakopitelniiSchet.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })}
                                    </div>
                                </th>
                                <th className="height-4" style={{ minWidth: "100px", fontWeight: "300" }}>
                                    <div className="bg bg-green" style={{ fontWeight: "bold" }}>
                                        {/* К выплате на текущий счет */}
                                        {(Number(kViplateNaTekushchiiSchet.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })}
                                    </div>
                                </th>
                                <th className="height-4" style={{ minWidth: "100px", fontWeight: "300" }}>
                                    <div className="bg bg-green" style={{ fontWeight: "bold" }}>
                                        {/* Проводка на накопительный */}
                                        {(Number(provodkaNaNakopitelnii.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })}
                                    </div>
                                </th>
                                <th className="height-4" style={{ minWidth: "100px", fontWeight: "300" }}>
                                    <div className="bg bg-green" style={{ fontWeight: "bold" }}>
                                        {/* Проводка на текущий */}
                                        {(Number(provodkaNaTekushchii.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })}
                                    </div>
                                </th>
                                <th className="height-4" style={{ minWidth: "200px", fontWeight: "300" }}>
                                    <div className="bg bg-grey">
                                        {/* Комментарий */}
                                    </div>
                                </th>
                            </tr>
                        </thead>
                        <tbody style={{ fontSize: "12px" }}>
                            {JSXMap(items || [], (item, cidx) => {
                                var disabled = item?.documentNaTekushchiiID || item?.documentNaNakopitelniiID;
                                return (<AgentskieVoznagrazhdeniyaKViplateRow key={cidx} item={item} idx={cidx} eventID={eventID} disabled={disabled} renderProps={{
                                    collection,
                                    setCollection,
                                    setCollectionItem,
                                    removeCollectionItem,
                                    collectionActions,
                                    modelActions,
                                    update,
                                    lastFuncStat,
                                    lock,
                                    unlock,
                                    loading
                                }} />)
                            })}
                        </tbody>
                    </table>
                </div>
            </Spin>
        </div>)
    }

    const FilterFromContextFilter = React.useCallback(() => [
        QueryParam("f-sum-obshcheeRaschetnoeVoznagrazhdenie", 0),
        QueryParam("f-sum-summaRaschetnayaNePromouter", 0),
        QueryParam("f-sum-summaNaNakopitelniiNePromouter", 0),
        QueryParam("f-sum-summaNaTekushchiiNePromouter", 0),
        QueryParam("f-sum-oborotPoPromouterstvu", 0),
        QueryParam("f-sum-summaRaschetnayaPromouter", 0),
        QueryParam("f-sum-summaNaNakopitelniiPromouter", 0),
        QueryParam("f-sum-summaNaTekushchiiPromouter", 0),
        QueryParam("f-sum-gonorarPriglashennogoArtista", 0),
        QueryParam("f-sum-dopZatratiNaPromoutera", 0),
        QueryParam("f-sum-kViplateGonorarKakPriglashenniiArtist", 0),
        QueryParam("f-sum-obshcheeVoznagrazhdenieKViplatePromouter", 0),
        QueryParam("f-sum-kViplateNaNakopitelniiSchet", 0),
        QueryParam("f-sum-kViplateNaTekushchiiSchet", 0),
        QueryParam("f-sum-provodkaNaNakopitelnii", 0),
        QueryParam("f-sum-provodkaNaTekushchii", 0),
    ], [eventID]);

    return (<div>
        <CollectionServer
            auth={auth}
            floatingFilter={true}
            disableScrollTo={true}
            allowFullscreen={true}
            name={"AgentskieVoznagrazhdeniyaKViplate"}
            // count={() => 5} // !!!! ИСПРАВИТЬ - сделать редактируемым или подобрать нужное количество !!!!
            // queryDetail={"collection"}
            source={`/api/agentskie-voznagrazhdeniya-k-viplate/by-user/page/${eventID}`}
            contextFilters={FilterFromContextFilter}
            filters={filters}
            size={"small"}
            mode={"list"}
            customRender={render}
        />
    </div>)
}

// function AgentskieVoznagrazhdeniyaReport(props) {
//     const { auth, eventID } = props;

//     const reinit = useCallback((
//         collection,
//         setCollection, update,
//         lock,
//         unlock) => {
//         update()
//     }, [eventID])

//     const filters = () => [
//         {
//             label: "Фамилия",
//             name: "okazannayaUsluga.polzovatel.lastname",
//             type: "string",
//             sort: true,
//             filter: true,
//             sorted: true
//         },
//         {
//             label: "Имя",
//             name: "okazannayaUsluga.polzovatel.firstname",
//             type: "string",
//             sort: true,
//             filter: true,
//         },
//         // {
//         //     name: "okazannayaUsluga.polzovatel.patronymic",
//         //     sort: true,
//         //     filter: true,
//         // },
//         // {
//         //     name: "okazannayaUsluga.polzovatel.email",
//         //     sort: true,
//         //     filter: true,
//         // },
//         // {
//         //     label: <span>Телефон<span style={{
//         //         fontStyle: "italic",
//         //         fontSize: "11px",
//         //         paddingLeft: "5px",
//         //         color: "#818181"
//         //     }}>(без +)</span></span>,
//         //     name: "okazannayaUsluga.polzovatel.phone",
//         //     // type: "string",
//         //     sort: true,
//         //     filter: true,
//         // },
//         {
//             label: "Пол",
//             name: "okazannayaUsluga.polzovatel.gender",
//             sort: true,
//             filter: true,
//         },
//         {
//             label: <FilterFieldLabel label="Промокод" badge="co" color="#919191" background="rgba(216, 216, 216, 0.2)" />,
//             name: "okazannayaUsluga.uchastik.tovarVZakaze.zakaz.promokodSsilka.promokod",
//             // queryComparer:"swsim", // sim, wsim, swsim
//             sort: true,
//             filter: true,
//         },
//         {
//             label: "Ячейка",
//             type: "object",
//             relation: {
//                 reference: {
//                     source: `/api/yacheikiuslugi/list-in-meropriyatie//${eventID}`,
//                     queryFilter: [
//                         QueryOrder("nazvanie", "ASC"),
//                     ],
//                 }
//             },
//             name: "okazannayaUsluga.uslugaKlientu.yacheikaUsluga",
//             filterType: "group",
//             display: (o) => o.nazvanie,
//             sort: true,
//             filter: true
//         },
//         {
//             label: "Услуга",
//             type: "object",
//             relation: {
//                 reference: {
//                     source: `/api/usluginameropriyatii/bymeropriyatie/${eventID}`,
//                     queryFilter: [
//                         QueryOrder("nazvanie", "ASC"),
//                     ],
//                 }
//             },
//             name: "okazannayaUsluga.uslugaKlientu.uslugaNaMeropriyatii",
//             filterType: "group",
//             display: (o) => o.nazvanie,
//             sort: true,
//             filter: true
//         },
//         {
//             label: "Школа",
//             name: "shkola.agentskoeVoznagrazhdenie.vtp.shkola",
//             source: "/papi/fed/school/list",
//             filterType: "group",
//             display: (o) => o.nazvanieShkoliTantsev,
//             queryFilter: [
//                 QueryOrder("nazvanieShkoliTantsev", "ASC"),
//             ],
//             sort: true,
//             filter: true
//         },
//         {
//             label: "Школа: Сумма",
//             name: "shkolaSumma",
//             // type: "int",
//             filterType: "range",
//             func: ["min", "max"],
//             sort: true,
//             filter: true,
//         },
//         {
//             label: "Промоутер",
//             name: "promouter.agentskoeVoznagrazhdenie.vtp",
//             source: `/api/meropriyatiya/promouteri-meropiyatiya/${eventID}`,
//             filterType: "group",
//             displayString: (o) => o.user.lastname + " " + o.user.firstname,
//             display: (o) => (<UserName item={o.user} noborder={true} />),
//             queryFilter: [
//                 QueryOrder("user.lastname", "ASC"),
//                 QueryOrder("user.firstname", "ASC"),
//             ],
//             sort: true,
//             filter: true
//         },
//         {
//             label: "Промоутер: Сумма",
//             name: "promouterSumma",
//             // type: "int",
//             filterType: "range",
//             func: ["min", "max"],
//             sort: true,
//             filter: true,
//         },
//         {
//             label: "Артист",
//             name: "artist.agentskoeVoznagrazhdenie.vtp",
//             source: `/api/meropriyatiya/artist-meropiyatiya/${eventID}`,
//             filterType: "group",
//             displayString: (o) => o.user.lastname + " " + o.user.firstname,
//             display: (o) => (<UserName item={o.user} noborder={true} />),
//             queryFilter: [
//                 QueryOrder("user.lastname", "ASC"),
//                 QueryOrder("user.firstname", "ASC"),
//             ],
//             sort: true,
//             filter: true
//         },
//         {
//             label: "Артист: Сумма",
//             name: "artistSumma",
//             // type: "int",
//             filterType: "range",
//             func: ["min", "max"],
//             sort: true,
//             filter: true,
//         },
//         {
//             label: "Куратор",
//             name: "kurator.agentskoeVoznagrazhdenie.vtp",
//             source: `/api/meropriyatiya/kuratori-meropiyatiya/${eventID}`,
//             filterType: "group",
//             displayString: (o) => o.user.lastname + " " + o.user.firstname,
//             display: (o) => (<UserName item={o.user} noborder={true} />),
//             queryFilter: [
//                 QueryOrder("user.lastname", "ASC"),
//                 QueryOrder("user.firstname", "ASC"),
//             ],
//             sort: true,
//             filter: true
//         },
//         {
//             label: "Куратор: Сумма",
//             name: "kuratorSumma",
//             // type: "int",
//             filterType: "range",
//             func: ["min", "max"],
//             sort: true,
//             filter: true,
//         },

//         {
//             label: "Сумма",
//             name: "summa",
//             // type: "int",
//             filterType: "range",
//             func: ["min", "max"],
//             sort: true,
//             filter: true,
//         },
//         {
//             label: "Суммарные комиссии",
//             name: "summarnieKomissii",
//             // type: "int",
//             filterType: "range",
//             func: ["min", "max"],
//             sort: true,
//             filter: true,
//         },
//     ];

//     const FilterFromContextFilter = React.useCallback(() => [
//         QueryParam("f-sum-shkolaSumma", 0),
//         QueryParam("f-sum-promouterSumma", 0),
//         QueryParam("f-sum-kuratorSumma", 0),
//         QueryParam("f-sum-artistSumma", 0),
//         QueryParam("f-sum-summa", 0),
//         QueryParam("f-sum-summarnieKomissii", 0),
//     ], [eventID]);

//     const render = (items, {
//         collection,
//         setCollection,
//         setCollectionItem,
//         removeCollectionItem,
//         collectionActions,
//         modelActions,
//         update,
//         lastFuncStat,
//         lock,
//         unlock,
//         loading
//     }) => {
//         const shkolaSumma = lastFuncStat?.shkolasumma?.sum || 0;
//         const promouterSumma = lastFuncStat?.promoutersumma?.sum || 0;
//         const artistSumma = lastFuncStat?.artistsumma?.sum || 0;
//         const kuratorSumma = lastFuncStat?.kuratorsumma?.sum || 0;
//         const summa = lastFuncStat?.summa?.sum || 0;
//         const summarnieKomissii = lastFuncStat?.summarniekomissii?.sum || 0;

//         return (<div>
//             <Spin spinning={loading} tip="Загрузка...">
//                 <div className='bg bg-grey' style={{ display: "flex", justifyContent: "space-between", padding: "3px", marginBottom: "5px" }}>
//                     <div style={{ display: "flex", gap: "3px" }}>

//                     </div>
//                     <div style={{ display: "flex", gap: "3px" }}>
//                         <Tooltip title="Обновить">
//                             <div className={`bg bg-grey pointer`} onClick={() => reinit(collection, setCollection, update, lock, unlock)} style={{ minWidth: "25px", maxWidth: "25px", display: "flex", height: "100%", justifyContent: "center", alignItems: "center" }}>
//                                 {!loading && <IssuesCloseOutlined />}
//                                 {loading && <Spin
//                                     indicator={
//                                         <LoadingOutlined
//                                             style={{
//                                                 color: "grey",
//                                                 fontSize: 12,
//                                             }}
//                                             spin
//                                         />
//                                     }
//                                 />}
//                             </div>
//                         </Tooltip>
//                     </div>
//                 </div>
//                 <div className='scrollable' style={{ backgroundColor: "white" }}>
//                     <table className="xtable" style={{ fontSize: "13px", lineHeight: "normal" }}>
//                         <thead>
//                             <tr>
//                                 <th className={`fixed height-8`} style={{ minWidth: "180px", backgroundColor: "white" }} rowSpan={2}>
//                                     <div className='bg bg-grey dark-1' style={{ minWidth: "unset" }}>Пользователь, на которого купили</div>
//                                 </th>
//                                 <th className="fixed height-8" style={{ left: "180px", minWidth: "200px", maxWidth: "200px", backgroundColor: "white" }} rowSpan={2}>
//                                     <div className='bg bg-grey dark-1' style={{ minWidth: "unset" }}>Ячейка</div>
//                                 </th>
//                                 <th className="height-8" style={{ minWidth: "100px", fontWeight: "300" }} rowSpan={2}>
//                                     <div className="bg bg-grey">
//                                         Сумма
//                                     </div>
//                                 </th>
//                                 <th className="height-8" style={{ minWidth: "100px", fontWeight: "300" }} rowSpan={2}>
//                                     <div className="bg bg-grey">
//                                         Сумма заказа
//                                     </div>
//                                 </th>
//                                 <th className="height-8" style={{ minWidth: "100px", fontWeight: "300" }} rowSpan={2}>
//                                     <div className="bg bg-grey">
//                                         Промокод
//                                     </div>
//                                 </th>
//                                 <th className="height-8" style={{ minWidth: "100px", fontWeight: "300" }} rowSpan={2}>
//                                     <div className="bg bg-grey">
//                                         Суммарные комиссии
//                                     </div>
//                                 </th>

//                                 <th className="height-8" style={{ minWidth: "200px", fontWeight: "300" }} colSpan={2}>
//                                     <div className="bg bg-blue light-2">
//                                         Школа
//                                     </div>
//                                 </th>
//                                 <th className="height-8" style={{ minWidth: "200px", fontWeight: "300" }} colSpan={2}>
//                                     <div className="bg bg-red light-2">
//                                         Промоутер
//                                     </div>
//                                 </th>
//                                 <th className="height-8" style={{ minWidth: "200px", fontWeight: "300" }} colSpan={2}>
//                                     <div className="bg bg-orange light-2">
//                                         Артист
//                                     </div>
//                                 </th>
//                                 <th className="height-8" style={{ minWidth: "200px", fontWeight: "300" }} colSpan={2}>
//                                     <div className="bg bg-green light-2">
//                                         Куратор
//                                     </div>
//                                 </th>
//                             </tr>
//                             <tr>
//                                 <th className="height-8" style={{ minWidth: "100px", fontWeight: "300" }}>
//                                     <div className="bg bg-blue light-2">
//                                         Пользователь
//                                     </div>
//                                 </th>
//                                 <th className="height-8" style={{ minWidth: "100px", fontWeight: "300" }}>
//                                     <div className="bg bg-blue light-2">
//                                         Сумма/Сумма к выплате
//                                     </div>
//                                 </th>

//                                 <th className="height-8" style={{ minWidth: "100px", fontWeight: "300" }}>
//                                     <div className="bg bg-red light-2">
//                                         Пользователь
//                                     </div>
//                                 </th>
//                                 <th className="height-8" style={{ minWidth: "100px", fontWeight: "300" }}>
//                                     <div className="bg bg-red light-2">
//                                         Сумма/Сумма к выплате
//                                     </div>
//                                 </th>

//                                 <th className="height-8" style={{ minWidth: "100px", fontWeight: "300" }}>
//                                     <div className="bg bg-orange light-2">
//                                         Пользователь
//                                     </div>
//                                 </th>
//                                 <th className="height-8" style={{ minWidth: "100px", fontWeight: "300" }}>
//                                     <div className="bg bg-orange light-2">
//                                         Сумма/Сумма к выплате
//                                     </div>
//                                 </th>

//                                 <th className="height-8" style={{ minWidth: "100px", fontWeight: "300" }}>
//                                     <div className="bg bg-green light-2">
//                                         Пользователь
//                                     </div>
//                                 </th>
//                                 <th className="height-8" style={{ minWidth: "100px", fontWeight: "300" }}>
//                                     <div className="bg bg-green light-2">
//                                         Сумма/Сумма к выплате
//                                     </div>
//                                 </th>
//                             </tr>
//                             <tr>
//                                 <th className={`fixed height-4`} style={{ minWidth: "180px", backgroundColor: "white" }}>
//                                     <div className='bg bg-grey dark-1' style={{ minWidth: "unset" }}>
//                                         {/* Пользователь, на которого купили */}
//                                     </div>
//                                 </th>
//                                 <th className="fixed height-4" style={{ left: "180px", minWidth: "200px", maxWidth: "200px", backgroundColor: "white" }}>
//                                     <div className='bg bg-grey dark-1' style={{ minWidth: "unset" }}>
//                                         {/* Ячейка */}
//                                     </div>
//                                 </th>
//                                 <th className="height-4" style={{ minWidth: "100px", fontWeight: "bold" }}>
//                                     <div className="bg bg-green">
//                                         {(Number(summa.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })}
//                                     </div>
//                                 </th>
//                                 <th className="height-4" style={{ minWidth: "100px", fontWeight: "bold" }}>
//                                     <div className="bg bg-grey">
//                                         {/* Сумма заказа */}
//                                     </div>
//                                 </th>
//                                 <th className="height-4" style={{ minWidth: "100px", fontWeight: "bold" }}>
//                                     <div className="bg bg-grey">
//                                         {/* Промокод */}
//                                     </div>
//                                 </th>
//                                 <th className="height-4" style={{ minWidth: "100px", fontWeight: "bold" }}>
//                                     <div className="bg bg-green">
//                                         {(Number(summarnieKomissii.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })}
//                                     </div>
//                                 </th>
//                                 <th className="height-4" style={{ minWidth: "100px", fontWeight: "bold" }}>
//                                     <div className="bg bg-blue light-2">
//                                         {/* Пользователь */}
//                                     </div>
//                                 </th>
//                                 <th className="height-4" style={{ minWidth: "100px", fontWeight: "bold" }}>

//                                     <div className="bg bg-green">
//                                         {(Number(shkolaSumma.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })}
//                                     </div>

//                                 </th>

//                                 <th className="height-4" style={{ minWidth: "100px", fontWeight: "bold" }}>
//                                     <div className="bg bg-red light-2">
//                                         {/* Пользователь */}
//                                     </div>
//                                 </th>
//                                 <th className="height-4" style={{ minWidth: "100px", fontWeight: "bold" }}>
//                                     <div className="bg bg-green">
//                                         {(Number(promouterSumma.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })}
//                                     </div>
//                                 </th>

//                                 <th className="height-4" style={{ minWidth: "100px", fontWeight: "bold" }}>
//                                     <div className="bg bg-orange light-2">
//                                         {/* Пользователь */}
//                                     </div>
//                                 </th>
//                                 <th className="height-4" style={{ minWidth: "100px", fontWeight: "bold" }}>
//                                     <div className="bg bg-green">
//                                         {(Number(artistSumma.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })}
//                                     </div>
//                                 </th>

//                                 <th className="height-4" style={{ minWidth: "100px", fontWeight: "bold" }}>
//                                     <div className="bg bg-green light-2">
//                                         {/* Пользователь */}
//                                     </div>
//                                 </th>
//                                 <th className="height-4" style={{ minWidth: "100px", fontWeight: "bold" }}>
//                                     <div className="bg bg-green">
//                                         {(Number(kuratorSumma.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })}
//                                     </div>
//                                 </th>
//                             </tr>
//                         </thead>
//                         <tbody style={{ fontSize: "12px" }}>
//                             {JSXMap(items || [], (item, idx) => {
//                                 return (<tr key={idx}>
//                                     <td className={`fixed height-5`} style={{ minWidth: "180px", backgroundColor: "white" }}>
//                                         <div className="bg bg-grey light-30 border-transparent" style={{ textAlign: "left", height: "100%" }}>
//                                             {item?.okazannayaUsluga?.polzovatelStrokoi && <span>{item?.okazannayaUsluga?.polzovatelStrokoi}</span>}
//                                             {item?.okazannayaUsluga?.polzovatel && <UserName item={item?.okazannayaUsluga?.polzovatel} noborder={true} />}
//                                             {/* <div style={{
//                                                 color: "rgba(0, 0, 0, 0.45)",
//                                                 textAlign: "left",
//                                                 textWrap: "nowrap",
//                                                 whiteSpace: "nowrap",
//                                                 overflow: "hidden",
//                                                 textOverflow: "ellipsis",
//                                                 fontSize: "12px",
//                                                 fontWeight: "lighter",
//                                                 paddingLeft: "20px"
//                                             }}>
//                                                 <span>{item?.vtp?.tipPolzovatelya?.opisanie}</span>
//                                             </div> */}
//                                         </div>
//                                     </td>
//                                     <td className="fixed height-5" style={{ left: "180px", minWidth: "200px", maxWidth: "200px", backgroundColor: "white" }}>
//                                         <div className="bg bg-grey dark-1 border-transparent" style={{ textAlign: "left", height: "100%" }}>
//                                             <div style={{ height: "unset" }}>{item?.okazannayaUsluga?.uslugaKlientu?.yacheikaUsluga?.nazvanie}</div>
//                                             {(item?.okazannayaUsluga?.uslugaKlientu?.yacheikaUsluga?.nazvanie !== item?.okazannayaUsluga?.uslugaKlientu?.uslugaNaMeropriyatii?.nazvanie) && <div style={{
//                                                 color: "rgba(0, 0, 0, 0.45)",
//                                                 textAlign: "left",
//                                                 textWrap: "nowrap",
//                                                 whiteSpace: "nowrap",
//                                                 overflow: "hidden",
//                                                 textOverflow: "ellipsis",
//                                                 fontSize: "12px",
//                                                 fontWeight: "lighter",
//                                             }}>
//                                                 <span>{item?.okazannayaUsluga?.uslugaKlientu?.uslugaNaMeropriyatii?.nazvanie}</span>
//                                             </div>}
//                                         </div>
//                                     </td>
//                                     <td className="height-5" style={{ minWidth: "100px", backgroundColor: "white" }}>
//                                         <div className="bg bg-orange dark-1 border-transparent" style={{ height: "100%", padding: "2px 5px", display: "flex", justifyContent: "center", alignItems: "center" }}>
//                                             <div>
//                                                 {(Number(item?.okazannayaUsluga?.summa?.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })}
//                                             </div>
//                                         </div>
//                                     </td>
//                                     <td className="height-5" style={{ minWidth: "100px", backgroundColor: "white" }}>
//                                         <div className="bg bg-grey dark-1 border-transparent" style={{ height: "100%", padding: "2px 5px", display: "flex", justifyContent: "center", alignItems: "center" }}>
//                                             <div>
//                                                 {(Number(item?.okazannayaUsluga?.uchastik?.tovarVZakaze?.zakaz?.obshchayaSumma?.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })}
//                                             </div>
//                                         </div>
//                                     </td>
//                                     <td className="height-5" style={{ minWidth: "100px", backgroundColor: "white" }}>
//                                         <div className="bg bg-grey dark-1 border-transparent" style={{ height: "100%", padding: "2px 5px", display: "flex", justifyContent: "center", alignItems: "center" }}>
//                                             <div>
//                                                 {item?.okazannayaUsluga?.uchastik?.tovarVZakaze?.zakaz?.promokodSsilka?.promokod}
//                                             </div>
//                                         </div>
//                                     </td>
//                                     <td className="height-5" style={{ minWidth: "100px", backgroundColor: "white" }}>
//                                         <div className="bg bg-grey dark-1 border-transparent" style={{ height: "100%", padding: "2px 5px", display: "flex", justifyContent: "center", alignItems: "center" }}>
//                                             <div>
//                                                 {(Number(item?.summarnieKomissii?.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })}
//                                             </div>
//                                         </div>
//                                     </td>

//                                     <td className="height-5" style={{ minWidth: "100px", backgroundColor: "white" }}>
//                                         <div className="bg bg-blue dark-1 border-transparent" style={{ height: "100%", padding: "2px 5px", display: "flex", justifyContent: "center", alignItems: "center" }}>
//                                             {item?.shkola && <div>
//                                                 <UserName item={item?.shkola?.agentskoeVoznagrazhdenie?.vtp?.user} noborder={true} />
//                                                 <div style={{
//                                                     color: "rgba(0, 0, 0, 0.45)",
//                                                     textAlign: "left",
//                                                     textWrap: "nowrap",
//                                                     whiteSpace: "nowrap",
//                                                     overflow: "hidden",
//                                                     textOverflow: "ellipsis",
//                                                     fontSize: "12px",
//                                                     fontWeight: "lighter",
//                                                     paddingLeft: "20px"
//                                                 }}>
//                                                     <div>{item?.shkola?.agentskoeVoznagrazhdenie?.vtp?.tipPolzovatelya?.opisanie}</div>
//                                                     {item?.shkola?.agentskoeVoznagrazhdenie?.vtp?.shkola?.nazvanieShkoliTantsev && <div>
//                                                         {item?.shkola?.agentskoeVoznagrazhdenie?.vtp?.shkola?.nazvanieShkoliTantsev}
//                                                     </div>}
//                                                 </div>

//                                             </div>}
//                                         </div>
//                                     </td>
//                                     <td className="height-5" style={{ minWidth: "100px", backgroundColor: "white" }}>
//                                         <div className="bg bg-blue dark-1 border-transparent" style={{ height: "100%", padding: "2px 5px", display: "flex", justifyContent: "center", alignItems: "center" }}>
//                                             {item?.shkola && <div>
//                                                 {(Number(item?.shkola?.summaVGonorare?.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })}
//                                             </div>}
//                                         </div>
//                                     </td>

//                                     <td className="height-5" style={{ minWidth: "100px", backgroundColor: "white" }}>
//                                         <div className="bg bg-red dark-1 border-transparent" style={{ height: "100%", padding: "2px 5px", display: "flex", justifyContent: "center", alignItems: "center" }}>
//                                             {item?.promouter && <div>
//                                                 <UserName item={item?.promouter?.agentskoeVoznagrazhdenie?.vtp?.user} noborder={true} />
//                                                 <div style={{
//                                                     color: "rgba(0, 0, 0, 0.45)",
//                                                     textAlign: "left",
//                                                     textWrap: "nowrap",
//                                                     whiteSpace: "nowrap",
//                                                     overflow: "hidden",
//                                                     textOverflow: "ellipsis",
//                                                     fontSize: "12px",
//                                                     fontWeight: "lighter",
//                                                     paddingLeft: "20px"
//                                                 }}>
//                                                     <span>{item?.promouter?.agentskoeVoznagrazhdenie?.vtp?.tipPolzovatelya?.opisanie}</span>
//                                                 </div>
//                                             </div>}
//                                         </div>
//                                     </td>
//                                     <td className="height-5" style={{ minWidth: "100px", backgroundColor: "white" }}>
//                                         <div className="bg bg-red dark-1 border-transparent" style={{ height: "100%", padding: "2px 5px", display: "flex", justifyContent: "center", alignItems: "center" }}>
//                                             {item?.promouter && <div>
//                                                 {(Number(item?.promouter?.summaVGonorare?.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })}
//                                             </div>}
//                                         </div>
//                                     </td>

//                                     <td className="height-5" style={{ minWidth: "100px", backgroundColor: "white" }}>
//                                         <div className="bg bg-orange dark-1 border-transparent" style={{ height: "100%", padding: "2px 5px", display: "flex", justifyContent: "center", alignItems: "center" }}>
//                                             {item?.artist && <div>
//                                                 <UserName item={item?.artist?.agentskoeVoznagrazhdenie?.vtp?.user} noborder={true} />
//                                                 <div style={{
//                                                     color: "rgba(0, 0, 0, 0.45)",
//                                                     textAlign: "left",
//                                                     textWrap: "nowrap",
//                                                     whiteSpace: "nowrap",
//                                                     overflow: "hidden",
//                                                     textOverflow: "ellipsis",
//                                                     fontSize: "12px",
//                                                     fontWeight: "lighter",
//                                                     paddingLeft: "20px"
//                                                 }}>
//                                                     <span>{item?.artist?.agentskoeVoznagrazhdenie?.vtp?.tipPolzovatelya?.opisanie}</span>
//                                                 </div>
//                                             </div>}
//                                         </div>
//                                     </td>
//                                     <td className="height-5" style={{ minWidth: "100px", backgroundColor: "white" }}>
//                                         <div className="bg bg-orange dark-1 border-transparent" style={{ height: "100%", padding: "2px 5px", display: "flex", justifyContent: "center", alignItems: "center" }}>
//                                             {item?.artist && <div>
//                                                 {(Number(item?.artist?.summaVGonorare?.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })}
//                                             </div>}
//                                         </div>
//                                     </td>

//                                     <td className="height-5" style={{ minWidth: "100px", backgroundColor: "white" }}>
//                                         <div className="bg bg-green dark-1 border-transparent" style={{ height: "100%", padding: "2px 5px", display: "flex", justifyContent: "center", alignItems: "center" }}>
//                                             {item?.kurator && <div>
//                                                 <UserName item={item?.kurator?.agentskoeVoznagrazhdenie?.vtp?.user} noborder={true} />
//                                                 <div style={{
//                                                     color: "rgba(0, 0, 0, 0.45)",
//                                                     textAlign: "left",
//                                                     textWrap: "nowrap",
//                                                     whiteSpace: "nowrap",
//                                                     overflow: "hidden",
//                                                     textOverflow: "ellipsis",
//                                                     fontSize: "12px",
//                                                     fontWeight: "lighter",
//                                                     paddingLeft: "20px"
//                                                 }}>
//                                                     <span>{item?.kurator?.agentskoeVoznagrazhdenie?.vtp?.tipPolzovatelya?.opisanie}</span>
//                                                 </div>
//                                             </div>}
//                                         </div>
//                                     </td>
//                                     <td className="height-5" style={{ minWidth: "100px", backgroundColor: "white" }}>
//                                         <div className="bg bg-green dark-1 border-transparent" style={{ height: "100%", padding: "2px 5px", display: "flex", justifyContent: "center", alignItems: "center" }}>
//                                             {item?.kurator && <div>
//                                                 {(Number(item?.kurator?.summaVGonorare?.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })}
//                                             </div>}
//                                         </div>
//                                     </td>
//                                 </tr>)
//                             })}
//                         </tbody>
//                     </table>
//                 </div>
//             </Spin>
//         </div>)
//     }

//     return (<div>
//         <CollectionServer
//             auth={auth}
//             floatingFilter={true}
//             disableScrollTo={true}
//             allowFullscreen={true}
//             // onCollectionChange={(items) => {
//             //     if (items && items.length) {
//             //         const disabled = items[0]?.meropriyatie?.raschetAgentskikhProizveden;
//             //         const disabled2 = !disabled || items[0]?.meropriyatie?.dokAgentskikhVoznagrSozdani;
//             //         setDisabled(disabled)
//             //         setDisabled2(disabled2)
//             //     }
//             // }}
//             name={"OtchetPoAgentskimVoznagrazhdeniyam"}
//             // count={() => 200} // !!!! ИСПРАВИТЬ - сделать редактируемым или подобрать нужное количество !!!!
//             // queryDetail={"collection"}
//             // source={`/api/agentskie-voznagrazhdeniya/report-okazannie-uslugi/filter/${eventID}`}
//             source={`/api/agentskie-voznagrazhdeniya/otchetpoagentskimvoznagrazhdeniyam/by-user/page/${eventID}`}
//             contextFilters={FilterFromContextFilter}
//             filters={filters}
//             size={"small"}
//             mode={"list"}
//             customRender={render}
//         />
//     </div>)
// }

export default function Selling(props) {
    const auth = useAuth();
    const { id } = props;
    const [event, setEvent] = useNearestObjectContext();

    return (<PageLayout hideSider={true}>
        <div style={{ backgroundColor: "white", padding: "0 15px", borderRadius: "4px" }}>
            <div style={{ padding: "10px 7px", fontSize: "16px" }}>
                <EventListItem
                    key={"event"}
                    event={event}
                    hideRoles={true}
                    hidePreview={true}
                    noNameLink={true}
                    hideBuyButton={true}
                    hideDetailButton={true}
                />
            </div>
            <div style={{ flex: "1 1 auto", overflowX: "auto" }}>
                <Tabs defaultActiveKey="1" style={{ width: "100%" }}
                    items={[
                        {
                            key: '1',
                            label: `Агентские вознаграждения`,
                            children: <AgentskieVoznagrazhdeniya auth={auth} eventID={event?.ID} />,
                        },
                        {
                            key: '2',
                            label: `Агентские вознаграждения к выплате`,
                            children: <AgentskieVoznagrazhdeniyaKViplate auth={auth} eventID={event?.ID} />,
                        },
                        // {
                        //     key: '3',
                        //     label: `Агентские вознаграждения (отчет)`,
                        //     children: <AgentskieVoznagrazhdeniyaReport auth={auth} eventID={event?.ID} />,
                        // },
                    ]}
                />
            </div>

        </div >
    </PageLayout>);
}
